(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4111],{

/***/ 81544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/livescore/match/[id]",
      function () {
        return __webpack_require__(56541);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_cn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72802);


var Goal = function(param) {
    var className = param.className, _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 15 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_1__.cn)("dark:text-white text-black", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_573_19836)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M13.3722 7.64071C13.3722 8.96185 12.9805 10.2533 12.2465 11.3518C11.5125 12.4503 10.4693 13.3064 9.24871 13.812C8.02814 14.3176 6.68506 14.4499 5.38931 14.1921C4.09356 13.9344 2.90334 13.2982 1.96916 12.364C1.03498 11.4298 0.398789 10.2396 0.141048 8.94387C-0.116692 7.64812 0.0155896 6.30504 0.521166 5.08447C1.02674 3.8639 1.88291 2.82067 2.98139 2.08668C4.07987 1.3527 5.37134 0.960938 6.69247 0.960938C8.46406 0.960938 10.1631 1.6647 11.4158 2.9174C12.6685 4.1701 13.3722 5.86912 13.3722 7.64071ZM12.0734 7.64071L11.372 8.25302L9.68353 6.67771L10.127 4.40473L11.0547 4.48823C10.3826 3.56085 9.43338 2.87084 8.34386 2.5177L8.71496 3.37864L6.69247 4.49751L4.6737 3.37308L5.04479 2.51213C3.95225 2.86429 3.00061 3.55592 2.32835 4.48637L3.2561 4.40288L3.69214 6.67585L2.00364 8.25117L1.31154 7.64071C1.30866 8.78353 1.67146 9.89731 2.34691 10.8192L2.55472 9.90627L4.83698 10.1939L5.81482 12.2906L5.02253 12.7693C6.11269 13.1237 7.2871 13.1237 8.37726 12.7693L7.56455 12.2906L8.54796 10.1939L10.8414 9.91369L11.0492 10.8266C11.7222 9.90132 12.0811 8.78482 12.0734 7.64071ZM5.39363 9.52218L4.59205 7.0618L6.69247 5.54029L8.79289 7.0618L7.99132 9.52218H5.39363Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_573_19836",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "13.3595",
                        height: "13.3595",
                        fill: "currentColor",
                        transform: "translate(0.0126953 0.960938)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Goal);


/***/ }),

/***/ 48508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useWindowSize() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: undefined,
        height: undefined
    }), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return windowSize;
}


/***/ }),

/***/ 56541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "buildMatchPageDescription": function() { return /* binding */ buildMatchPageDescription; },
  "buildMatchPageTitle": function() { return /* binding */ buildMatchPageTitle; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/molecules/LivescoreLayout/LivescoreLayout.tsx + 9 modules
var LivescoreLayout = __webpack_require__(33882);
// EXTERNAL MODULE: ./src/components/atoms/LivescoreEntityLink/LivescoreEntityLink.tsx
var LivescoreEntityLink = __webpack_require__(61638);
// EXTERNAL MODULE: ./src/components/icons/ArrowRightCorner.tsx
var ArrowRightCorner = __webpack_require__(50680);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/livescore/client.ts + 20 modules
var client = __webpack_require__(79800);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/context/AppContext.tsx
var AppContext = __webpack_require__(64574);
;// CONCATENATED MODULE: ./src/context/LivescoreMatchContext.tsx








var LivescoreMatchContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var PREMATCH_STATUSES = [
    "not_started",
    "postponed",
    "suspended",
    "delayed",
    "cancelled",
    "abandoned"
];
var LIVE_STATUSES = [
    "started",
    "live",
    "interrupted"
];
var LivescoreMatchProvider = function(param) {
    var children = param.children, initMatch = param.initMatch, ads = param.ads;
    var ref;
    var appendJsonLd = (0,AppContext/* useApp */.q)().appendJsonLd;
    var ref1 = (0,react.useState)(initMatch), match = ref1[0], setMatch = ref1[1];
    var ref2 = (0,react.useState)(null), timeline = ref2[0], setTimeline = ref2[1];
    var ref3 = (0,react.useState)(true), timelineLoading = ref3[0], setTimelineLoading = ref3[1];
    var ref4 = (0,react.useState)(null), formation = ref4[0], setFormation = ref4[1];
    var ref5 = (0,react.useState)(null), substitutions = ref5[0], setSubstitutions = ref5[1];
    var ref6 = (0,react.useState)(null), starters = ref6[0], setStarters = ref6[1];
    var ref7 = (0,react.useState)(null), substitutes = ref7[0], setSubstitutes = ref7[1];
    var ref8 = (0,react.useState)(null), h2h = ref8[0], setH2H = ref8[1];
    var ref9 = (0,react.useState)({
        step: "fetching",
        success: true,
        preview: undefined
    }), matchPreview = ref9[0], setMatchPreview = ref9[1];
    (0,react.useEffect)(function() {
        if (PREMATCH_STATUSES.includes(initMatch.sport_event_status.status)) return;
        function getTimeline() {
            return _getTimeline.apply(this, arguments);
        }
        function _getTimeline() {
            _getTimeline = (0,_async_to_generator/* default */.Z)(function() {
                var timelineResponse;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                client/* livescoreClient.apiMatchEventIdTimelineGet */.Z.apiMatchEventIdTimelineGet({
                                    eventId: match.sport_event.id
                                })
                            ];
                        case 1:
                            timelineResponse = _state.sent();
                            if (timelineResponse.data.data.match_timeline) {
                                setTimeline(timelineResponse.data.data.match_timeline);
                            }
                            setTimelineLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return _getTimeline.apply(this, arguments);
        }
        getTimeline();
    }, [
        initMatch
    ]);
    (0,react.useEffect)(function() {
        var liveMatchInterval;
        if (LIVE_STATUSES.includes(match.sport_event_status.status)) {
            liveMatchInterval = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var ref, liveMatchResponse, formationsResponse;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.log("Fetching live match data");
                            return [
                                4,
                                Promise.all([
                                    client/* livescoreClient.apiMatchEventIdAllLiveGet */.Z.apiMatchEventIdAllLiveGet({
                                        eventId: match.sport_event.id
                                    }),
                                    formation ? client/* livescoreClient.apiFormationsEventIdGet */.Z.apiFormationsEventIdGet({
                                        eventId: match.sport_event.id
                                    }) : Promise.resolve(null)
                                ])
                            ];
                        case 1:
                            ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), liveMatchResponse = ref[0], formationsResponse = ref[1];
                            if (liveMatchResponse.data.data.match) {
                                console.log("Fetched live match data successfully");
                                setMatch(liveMatchResponse.data.data.match);
                                setTimeline(liveMatchResponse.data.data.match_timeline);
                                if (!liveMatchResponse.data.data.match_timeline) console.log("Timeline is undefined", liveMatchResponse.data.data.match_timeline);
                                return [
                                    2
                                ];
                            }
                            if (formationsResponse !== null && formationsResponse.data.data.formations) {
                                setFormation(formationsResponse.data.data.formations);
                            }
                            console.error("Cloudn't get live match data.");
                            return [
                                2
                            ];
                    }
                });
            }), 10000);
        }
        // Fetch Match Preview
        var eventSource = new EventSource("".concat("https://fangoltestscore.fangol.pl", "/api/match/").concat(match.sport_event.id, "/preview"));
        eventSource.addEventListener("status", function(e) {
            var data = JSON.parse(e.data);
            setMatchPreview(data);
            if (data.state === "no_data") {
                eventSource.close();
            }
        });
        eventSource.addEventListener("result", function(e) {
            var data = JSON.parse(e.data);
            setMatchPreview(data);
            eventSource.close();
        });
        eventSource.addEventListener("error", function(e) {
            setMatchPreview({
                step: "error",
                success: false
            });
            eventSource.close();
        });
        return function() {
            if (liveMatchInterval) {
                clearInterval(liveMatchInterval);
            }
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        var data = {
            "@context": "https://schema.org",
            "@type": "SportsEvent",
            name: "".concat(match.sport_event.competitors[0].name, " vs ").concat(match.sport_event.competitors[1].name),
            sport: "Soccer",
            startDate: match.sport_event.start_time,
            homeTeam: {
                "@type": "SportsTeam",
                name: (ref = match.sport_event.competitors.find(function(c) {
                    return c.qualifier === "home";
                })) === null || ref === void 0 ? void 0 : ref.name
            },
            awayTeam: {
                "@type": "SportsTeam",
                name: (ref1 = match.sport_event.competitors.find(function(c) {
                    return c.qualifier === "away";
                })) === null || ref1 === void 0 ? void 0 : ref1.name
            },
            location: {}
        };
        if ((ref2 = match.sport_event) === null || ref2 === void 0 ? void 0 : ref2.venue) {
            var ref4, ref5, ref6;
            data["location"] = {
                "@type": "Place",
                name: (ref4 = match.sport_event.venue) === null || ref4 === void 0 ? void 0 : ref4.name,
                address: {
                    "@type": "PostalAddress",
                    addressLocality: (ref5 = match.sport_event.venue) === null || ref5 === void 0 ? void 0 : ref5.city_name,
                    addressCountry: (ref6 = match.sport_event.venue) === null || ref6 === void 0 ? void 0 : ref6.country_name
                }
            };
        }
        if (matchPreview === null || matchPreview === void 0 ? void 0 : (ref3 = matchPreview.preview) === null || ref3 === void 0 ? void 0 : ref3.preview) {
            var ref7;
            data["description"] = matchPreview === null || matchPreview === void 0 ? void 0 : (ref7 = matchPreview.preview) === null || ref7 === void 0 ? void 0 : ref7.preview;
        }
        appendJsonLd(data);
    }, [
        matchPreview === null || matchPreview === void 0 ? void 0 : (ref = matchPreview.preview) === null || ref === void 0 ? void 0 : ref.preview,
        match.sport_event.id,
        matchPreview === null || matchPreview === void 0 ? void 0 : matchPreview.generated_at
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LivescoreMatchContext.Provider, {
        value: {
            match: match,
            ads: ads,
            timeline: timeline,
            timelineLoading: timelineLoading,
            formation: formation,
            setFormation: setFormation,
            substitutions: substitutions,
            setSubstitutions: setSubstitutions,
            starters: starters,
            setStarters: setStarters,
            substitutes: substitutes,
            setSubstitutes: setSubstitutes,
            h2h: h2h,
            setH2H: setH2H,
            matchPreview: matchPreview
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: (matchPreview === null || matchPreview === void 0 ? void 0 : matchPreview.generated_at) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "last-modified",
                    content: matchPreview.generated_at
                }) : null
            }),
            children
        ]
    });
};
var useLivescoreMatch = function() {
    var context = (0,react.useContext)(LivescoreMatchContext);
    if (!context) {
        throw new Error("useLivescoreMatch must be used within an LivescoreMatchProvider");
    }
    return context;
};

// EXTERNAL MODULE: ./src/utils/cn.ts + 1 modules
var cn = __webpack_require__(72802);
// EXTERNAL MODULE: ./src/utils/getMatchStatus.ts
var getMatchStatus = __webpack_require__(47370);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreMatchResult/LivescoreMatchResult.tsx







function formatISODate(isoDate) {
    var date = new Date(isoDate);
    // Sprawdzenie, czy data jest poprawna
    if (isNaN(date.getTime())) {
        return "Invalid Date";
    }
    var day = String(date.getDate()).padStart(2, "0");
    var month = String(date.getMonth() + 1).padStart(2, "0"); // Miesiące są 0-indeksowane
    var year = date.getFullYear();
    var hours = String(date.getHours()).padStart(2, "0");
    var minutes = String(date.getMinutes()).padStart(2, "0");
    return "".concat(day, ".").concat(month, ".").concat(year, " - ").concat(hours, ":").concat(minutes);
}
var StatusBadge = function(param) {
    var status = param.status;
    var ref, ref1, ref2;
    var plStatus = (0,getMatchStatus/* getMatchStatus */.L$)(status);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,cn.cn)("absolute -top-5 sm:-top-2 left-1/2 -translate-x-1/2 py-1.5 px-2 font-extrabold sm:!text-xxs !text-[8px] uppercase rounded", status && getMatchStatus/* redStatuses.includes */.Gr.includes(plStatus) && "bg-red-900 text-red-500", status && (getMatchStatus/* greenStatuses.includes */.YH.includes(plStatus) || getMatchStatus/* grayStatuses.includes */.pL.includes(plStatus)) && "dark:bg-green-900 bg-primary-150 text-primary-600", status && getMatchStatus/* blackStatuses.includes */.jA.includes(plStatus) && "dark:bg-black-500 bg-gray-200 text-gray-400"),
        children: [
            plStatus,
            " ",
            ((ref = status.clock) === null || ref === void 0 ? void 0 : ref.played) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    (ref1 = status.clock) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.played) === null || ref2 === void 0 ? void 0 : ref2.split(":")[0],
                    "’"
                ]
            })
        ]
    });
};
var TeamElement = function(param) {
    var team = param.team, winner = param.winner, isAhref = param.isAhref;
    var _slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LivescoreEntityLink/* default */.Z, {
        href: "/livescore/team/".concat((_slug = team.slug) !== null && _slug !== void 0 ? _slug : team.id),
        className: "flex flex-col items-center justify-center w-full sm:gap-6 gap-2 px-4",
        isAhref: isAhref,
        children: [
            team.logo_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-10 h-10 md:w-20 md:h-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: team.logo_url,
                    alt: team.name,
                    layout: "fill",
                    sizes: "(max-width: 600px) 40px, 80px",
                    objectFit: "contain"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sm:w-20 sm:h-20 w-10 h-10 bg-green-400 rounded-full flex items-center justify-center overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sm:text-xl text-sm font-bold text-gray-800 m-0 pt-0.5",
                    children: team.abbreviation
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex sm:gap-1 relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "dark:text-white text-black font-semibold sm:text-lg text-[10px] text-center line-clamp-2 overflow-ellipsis w-full",
                    children: [
                        team.name,
                        " ",
                        team.abbreviation && "(".concat(team.abbreviation, ")"),
                        winner && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "inline-block align-top ml-0.5 scale-50 sm:scale-100 origin-top-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightCorner/* default */.Z, {
                                color: "#31C46C",
                                width: 16
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var LivescoreMatchResult = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var match = useLivescoreMatch().match;
    var _home_score, _away_score, _home_score1, _away_score1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full dark:bg-black-500 bg-white_theme-50 sm:pb-12 pb-6 relative sm:pt-4 pt-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 match-linear-gradient z-0",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative z-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full text-center py-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-gray-400 font-medium sm:text-xxs text-[7px]",
                            children: match.sport_event.start_time ? formatISODate(match.sport_event.start_time) : ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center pt-4 sm:pt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center w-full justify-between relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamElement, {
                                    team: match.sport_event.competitors[0],
                                    isAhref: match.seoLinks,
                                    winner: match.sport_event_status.aggregate_winner_id === match.sport_event.competitors[0].id
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-3xl sm:text-[50px] text-primary-600 font-gameplay space-x-1 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: (_home_score = match.sport_event_status.home_score) !== null && _home_score !== void 0 ? _home_score : "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: (_away_score = match.sport_event_status.away_score) !== null && _away_score !== void 0 ? _away_score : "-"
                                        })
                                    ]
                                }),
                                ((ref = match.sport_event_status) === null || ref === void 0 ? void 0 : (ref1 = ref.period_scores) === null || ref1 === void 0 ? void 0 : ref1[3]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-[13px] sm:text-[10px] text-gray-400 space-x-1 absolute left-1/2 top-[88%] -translate-x-1/2 -translate-y-1/2",
                                    children: [
                                        "(",
                                        (_home_score1 = (ref2 = match.sport_event_status) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.period_scores) === null || ref3 === void 0 ? void 0 : ref3[3].home_score) !== null && _home_score1 !== void 0 ? _home_score1 : "x",
                                        "-",
                                        (_away_score1 = (ref4 = match.sport_event_status) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.period_scores) === null || ref5 === void 0 ? void 0 : ref5[3].away_score) !== null && _away_score1 !== void 0 ? _away_score1 : "x",
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamElement, {
                                    team: match.sport_event.competitors[1],
                                    isAhref: match.seoLinks,
                                    winner: match.sport_event_status.aggregate_winner_id === match.sport_event.competitors[1].id
                                }),
                                !PREMATCH_STATUSES.includes(match.sport_event_status.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusBadge, {
                                    status: match.sport_event_status
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LivescoreMatchResult_LivescoreMatchResult = (LivescoreMatchResult);

// EXTERNAL MODULE: ./src/components/atoms/LivescoreFavoriteToggler/LivescoreFavoriteToggler.tsx
var LivescoreFavoriteToggler = __webpack_require__(57591);
// EXTERNAL MODULE: ./src/context/LivescoreLayoutContext.tsx
var LivescoreLayoutContext = __webpack_require__(95599);
// EXTERNAL MODULE: ./src/utils/countryCode.ts
var utils_countryCode = __webpack_require__(64027);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChevronLeftIcon.js

function ChevronLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 19.5 8.25 12l7.5-7.5"
  }));
}
const ForwardRef = /*#__PURE__*/ react.forwardRef(ChevronLeftIcon);
/* harmony default export */ var esm_ChevronLeftIcon = (ForwardRef);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreMatchHeader/LivescoreMatchHeader.tsx








var LivescoreMatchHeader = function() {
    var ref, ref1, ref2, ref3, ref4;
    var match = useLivescoreMatch().match;
    var ref5 = (0,LivescoreLayoutContext/* useLivescoreLayout */.z)(), favoriteCompetitors = ref5.favoriteCompetitors, toggleMatchToFavorites = ref5.toggleMatchToFavorites, favoriteMatches = ref5.favoriteMatches;
    var competitionName = ((ref = match === null || match === void 0 ? void 0 : match.sport_event.sport_event_context) === null || ref === void 0 ? void 0 : (ref1 = ref.competition) === null || ref1 === void 0 ? void 0 : ref1.name) || "";
    var countryCode = ((ref2 = match === null || match === void 0 ? void 0 : match.sport_event.sport_event_context) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.competition) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.category) === null || ref4 === void 0 ? void 0 : ref4.country_code) || "";
    var alpha2 = countryCode ? (0,utils_countryCode/* convertAlpha */.Ob)(countryCode) : "un";
    var countryName = countryCode ? (0,utils_countryCode/* getCountryName */.pD)(countryCode) : "Międzynarodowa";
    var hasFavoriteCompetitor = favoriteCompetitors.has(match.sport_event.competitors[0].id) || favoriteCompetitors.has(match.sport_event.competitors[1].id);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "dark:bg-black-400 bg-white_theme-50 rounded-t-lg flex justify-between items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/livescore",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "h-10 w-10 flex items-center justify-center dark:bg-gray-650 bg-white_theme-100 rounded-tl-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronLeftIcon, {
                                width: 16,
                                height: 16,
                                className: "dark:text-white text-black"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative h-5 w-5 rounded-full overflow-hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "https://flagcdn.com/".concat(alpha2 === null || alpha2 === void 0 ? void 0 : alpha2.toLocaleLowerCase(), ".svg"),
                                    alt: "Liga ".concat(countryName !== null && countryName !== void 0 ? countryName : "Międzynarodowa"),
                                    layout: "fill",
                                    objectFit: "cover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-xxs font-bold text-black dark:text-white",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "!font-medium text-gray-400 uppercase",
                                        children: [
                                            countryName,
                                            ": "
                                        ]
                                    }),
                                    competitionName
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center p-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreFavoriteToggler/* default */.Z, {
                    className: (0,cn.cn)(hasFavoriteCompetitor && "cursor-default"),
                    disabled: hasFavoriteCompetitor,
                    onClick: function() {
                        return toggleMatchToFavorites(match.sport_event.id);
                    },
                    isFavorite: favoriteMatches.has(match.sport_event.id) || hasFavoriteCompetitor,
                    id: match.sport_event.id
                })
            })
        ]
    });
};
/* harmony default export */ var LivescoreMatchHeader_LivescoreMatchHeader = (LivescoreMatchHeader);

// EXTERNAL MODULE: ./src/components/atoms/Button/index.ts + 1 modules
var Button = __webpack_require__(98599);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(13245);
// EXTERNAL MODULE: ./src/components/atoms/Skeleton/Skeleton.tsx
var Skeleton = __webpack_require__(28254);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreH2HDetails/LivescoreH2HDetailsSkeleton.tsx


var MatchCardSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full items-center justify-between px-4 py-2 gap-4 dark:bg-black-400 bg-white_theme-50 rounded-lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                className: "w-8 h-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        className: "h-4 w-4 rounded-full"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        className: "w-16 h-3"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        className: "h-4 w-4 rounded-full"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        className: "w-16 h-3"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center space-y-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "w-3 h-3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "w-3 h-3"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                className: "w-5 h-5 rounded-sm"
            })
        ]
    });
};
var LastMatchesSkeleton = function(param) {
    var _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    className: "w-32 h-3"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchCardSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchCardSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchCardSkeleton, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-fit mx-auto flex items-center justify-center gap-1.5 mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "w-24 h-3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "w-3.5 h-3.5"
                    })
                ]
            })
        ]
    });
};
var LivescoreH2HDetailsSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LastMatchesSkeleton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LastMatchesSkeleton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LastMatchesSkeleton, {
                showTitle: true
            })
        ]
    });
};
/* harmony default export */ var LivescoreH2HDetails_LivescoreH2HDetailsSkeleton = (LivescoreH2HDetailsSkeleton);

// EXTERNAL MODULE: ./src/components/molecules/LivescoreMatchCard/LivescoreMatchCard.tsx
var LivescoreMatchCard = __webpack_require__(34688);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreH2HDetails/LivescoreH2HDetails.tsx










var LastMatches = function(param) {
    var competitorName = param.competitorName, matches = param.matches, between = param.between, _showWinner = param.showWinner, showWinner = _showWinner === void 0 ? true : _showWinner;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        children: [
            competitorName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-black dark:text-white font-light sm:text-[13px] text-[10px] mb-2",
                children: [
                    "Ostatnie mecze: ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        className: "font-medium",
                        children: competitorName
                    })
                ]
            }) : between ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-black dark:text-white font-medium sm:text-[13px] text-[10px] mb-2",
                children: "Mecze Bezpośrednie"
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "list-none pl-0 space-y-2",
                children: matches === null || matches === void 0 ? void 0 : matches.map(function(match) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchCard/* default */.Z, {
                        match: match,
                        showWinnerStatus: showWinner
                    }, match.id);
                })
            })
        ]
    });
};
var LivescoreH2HDetails = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = useLivescoreMatch(), match = ref4.match, h2h = ref4.h2h, setH2H = ref4.setH2H;
    var ref5 = (0,react.useState)(true), loading = ref5[0], setLoading = ref5[1];
    (0,react.useEffect)(function() {
        function getH2H() {
            return _getH2H.apply(this, arguments);
        }
        function _getH2H() {
            _getH2H = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            console.log((ref4 = (ref = match.sport_event.competitors.find(function(param) {
                                var qualifier = param.qualifier;
                                return qualifier === "home";
                            })) === null || ref === void 0 ? void 0 : ref.id) !== null && ref4 !== void 0 ? ref4 : "");
                            console.log((ref5 = (ref1 = match.sport_event.competitors.find(function(param) {
                                var qualifier = param.qualifier;
                                return qualifier === "away";
                            })) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref5 !== void 0 ? ref5 : "");
                            return [
                                4,
                                client/* livescoreClient.apiH2hGet */.Z.apiH2hGet({
                                    homeId: (ref6 = (ref2 = match.sport_event.competitors.find(function(param) {
                                        var qualifier = param.qualifier;
                                        return qualifier === "home";
                                    })) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref6 !== void 0 ? ref6 : "",
                                    awayId: (ref7 = (ref3 = match.sport_event.competitors.find(function(param) {
                                        var qualifier = param.qualifier;
                                        return qualifier === "away";
                                    })) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref7 !== void 0 ? ref7 : ""
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            setH2H(response.data.data.h2h);
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return _getH2H.apply(this, arguments);
        }
        if (!h2h) {
            getH2H();
        } else {
            setLoading(false);
        }
    }, []);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreH2HDetails_LivescoreH2HDetailsSkeleton, {});
    }
    var ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LastMatches, {
                        competitorName: (ref6 = (ref = match.sport_event.competitors.find(function(param) {
                            var qualifier = param.qualifier;
                            return qualifier === "home";
                        })) === null || ref === void 0 ? void 0 : ref.name) !== null && ref6 !== void 0 ? ref6 : "",
                        matches: h2h === null || h2h === void 0 ? void 0 : h2h.home
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LivescoreEntityLink/* default */.Z, {
                        href: "/livescore/team/".concat((ref1 = match.sport_event.competitors.find(function(param) {
                            var qualifier = param.qualifier;
                            return qualifier === "home";
                        })) === null || ref1 === void 0 ? void 0 : ref1.id),
                        className: "w-fit mx-auto flex items-center justify-center gap-1.5 text-primary-600 font-semibold sm:text-[12px] text-[9px] mt-2",
                        children: [
                            "Pokaż więcej mecz\xf3w",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                width: 14,
                                height: 14,
                                className: "mt-0.5 sm:w-[12px] w-[10px]",
                                strokeWidth: 3
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LastMatches, {
                        competitorName: (ref7 = (ref2 = match.sport_event.competitors.find(function(param) {
                            var qualifier = param.qualifier;
                            return qualifier === "away";
                        })) === null || ref2 === void 0 ? void 0 : ref2.name) !== null && ref7 !== void 0 ? ref7 : "",
                        matches: h2h === null || h2h === void 0 ? void 0 : h2h.away
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/livescore/team/".concat((ref3 = match.sport_event.competitors.find(function(param) {
                            var qualifier = param.qualifier;
                            return qualifier === "away";
                        })) === null || ref3 === void 0 ? void 0 : ref3.id),
                        className: "w-fit mx-auto flex items-center justify-center gap-1.5 text-primary-600 font-semibold sm:text-[12px] text-[9px] mt-2",
                        children: [
                            "Pokaż więcej mecz\xf3w",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                width: 14,
                                height: 14,
                                className: "mt-0.5 sm:w-[12px] w-[10px]",
                                strokeWidth: 3
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LastMatches, {
                between: true,
                matches: h2h === null || h2h === void 0 ? void 0 : h2h.away,
                showWinner: false
            })
        ]
    });
};
/* harmony default export */ var LivescoreH2HDetails_LivescoreH2HDetails = (LivescoreH2HDetails);

;// CONCATENATED MODULE: ./src/components/icons/Location.tsx

var Location = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "11",
        height: "12",
        viewBox: "0 0 11 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_559_1375)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.88754 8.92927C8.39289 8.7581 7.74838 8.62863 7.03309 8.55446C7.14287 8.3878 7.25528 8.21286 7.368 8.03169C8.38948 6.3897 8.90743 5.09062 8.90743 4.17053C8.90741 2.34422 7.42159 0.858398 5.59529 0.858398C3.769 0.858398 2.28318 2.34422 2.28318 4.17053C2.28318 5.09062 2.80113 6.3897 3.82261 8.03169C3.93531 8.21286 4.04773 8.3878 4.15752 8.55446C3.44225 8.62863 2.7977 8.75808 2.30307 8.92927C1.53173 9.19619 1.14062 9.55325 1.14062 9.99049C1.14062 10.4805 1.6283 10.8678 2.59008 11.1418C3.39726 11.3718 4.46454 11.4984 5.59529 11.4984C6.72604 11.4984 7.79333 11.3718 8.60053 11.1418C9.56231 10.8678 10.05 10.4805 10.05 9.99047C10.05 9.55325 9.6589 9.19619 8.88754 8.92927ZM2.95138 4.17053C2.95138 2.71265 4.13743 1.5266 5.59529 1.5266C7.05316 1.5266 8.23921 2.71265 8.23921 4.17053C8.23921 4.95174 7.74293 6.16296 6.80406 7.67319C6.34196 8.41648 5.87536 9.06446 5.59527 9.43977C5.3152 9.06448 4.8486 8.4165 4.38649 7.67319C3.44766 6.16296 2.95138 4.95176 2.95138 4.17053ZM8.41745 10.4992C7.6681 10.7126 6.66584 10.8302 5.59529 10.8302C4.52475 10.8302 3.52247 10.7126 2.77314 10.4992C1.97645 10.2722 1.8088 10.029 1.8088 9.99049C1.8088 9.95416 1.93563 9.7635 2.52158 9.56073C3.04978 9.37796 3.77787 9.24669 4.58751 9.18711C5.00407 9.78156 5.31371 10.1732 5.33353 10.1981C5.39692 10.278 5.49332 10.3246 5.59529 10.3246C5.69727 10.3246 5.79365 10.278 5.85705 10.1981C5.87688 10.1731 6.18652 9.78156 6.60308 9.18711C7.41274 9.24669 8.14083 9.37794 8.66903 9.56073C9.25496 9.76352 9.38178 9.95416 9.38178 9.99047C9.38176 10.029 9.21414 10.2722 8.41745 10.4992Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.59487 2.62354C4.7413 2.62354 4.04688 3.31798 4.04688 4.17153C4.04688 5.02508 4.74132 5.71953 5.59487 5.71953C6.44842 5.71953 7.14287 5.02508 7.14287 4.17153C7.14287 3.31798 6.44844 2.62354 5.59487 2.62354ZM5.59487 5.05135C5.10975 5.05135 4.71508 4.65667 4.71508 4.17155C4.71508 3.68641 5.10975 3.29176 5.59487 3.29176C6.07999 3.29176 6.47467 3.68643 6.47467 4.17155C6.47467 4.65667 6.07999 5.05135 5.59487 5.05135Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_559_1375",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10.64",
                        height: "10.64",
                        fill: "white",
                        transform: "translate(0.275391 0.858398)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_Location = (Location);

;// CONCATENATED MODULE: ./src/components/icons/People.tsx


var People = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "11",
        height: "11",
        viewBox: "0 0 11 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_559_1382)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.3568 5.70184H8.31528C8.17353 5.70184 8.03629 5.72121 7.90568 5.75683C7.64804 5.25035 7.12202 4.90234 6.5159 4.90234H4.67489C4.06876 4.90234 3.54274 5.25035 3.2851 5.75683C3.15449 5.72121 3.01725 5.70184 2.8755 5.70184H1.83398C0.974576 5.70184 0.275391 6.40103 0.275391 7.26043V8.92539C0.275391 9.44103 0.694902 9.86054 1.21055 9.86054H9.98024C10.4959 9.86054 10.9154 9.44103 10.9154 8.92539V7.26043C10.9154 6.40103 10.2162 5.70184 9.3568 5.70184ZM3.11629 6.46098V9.23713H1.21055C1.03867 9.23713 0.898828 9.09729 0.898828 8.92541V7.26046C0.898828 6.74481 1.31834 6.3253 1.83398 6.3253H2.8755C2.96012 6.3253 3.04206 6.33679 3.12007 6.35797C3.11783 6.39207 3.11629 6.42636 3.11629 6.46098ZM7.45105 9.23713H3.73973V6.46096C3.73973 5.94531 4.15924 5.5258 4.67489 5.5258H6.5159C7.03154 5.5258 7.45105 5.94531 7.45105 6.46096V9.23713ZM10.292 8.92541C10.292 9.09729 10.1521 9.23713 9.98024 9.23713H8.07449V6.46096C8.07449 6.42632 8.07295 6.39203 8.07071 6.35795C8.14872 6.33679 8.23066 6.32528 8.31528 6.32528H9.3568C9.87244 6.32528 10.292 6.74479 10.292 7.26043V8.92541Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.35471 2.75586C1.59102 2.75586 0.969727 3.37716 0.969727 4.14085C0.969706 4.90454 1.59102 5.52583 2.35471 5.52583C3.11838 5.52583 3.7397 4.90454 3.7397 4.14085C3.7397 3.37716 3.1184 2.75586 2.35471 2.75586ZM2.35469 4.9024C1.93477 4.9024 1.59314 4.56077 1.59314 4.14085C1.59314 3.72092 1.93477 3.3793 2.35469 3.3793C2.77462 3.3793 3.11624 3.72092 3.11624 4.14085C3.11624 4.56077 2.77462 4.9024 2.35469 4.9024Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.59544 1.03613C4.57516 1.03613 3.74512 1.86618 3.74512 2.88645C3.74512 3.90673 4.57516 4.73677 5.59544 4.73677C6.61571 4.73677 7.44576 3.90673 7.44576 2.88645C7.44576 1.8662 6.61571 1.03613 5.59544 1.03613ZM5.59544 4.11334C4.91893 4.11334 4.36855 3.56297 4.36855 2.88645C4.36855 2.20996 4.91893 1.65957 5.59544 1.65957C6.27195 1.65957 6.82232 2.20994 6.82232 2.88645C6.82232 3.56297 6.27195 4.11334 5.59544 4.11334Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.83616 2.75586C8.07249 2.75586 7.45117 3.37716 7.45117 4.14085C7.45119 4.90454 8.07249 5.52583 8.83616 5.52583C9.59985 5.52583 10.2211 4.90454 10.2211 4.14085C10.2211 3.37716 9.59985 2.75586 8.83616 2.75586ZM8.83616 4.9024C8.41625 4.9024 8.07461 4.56077 8.07461 4.14085C8.07463 3.72092 8.41625 3.3793 8.83616 3.3793C9.25609 3.3793 9.59771 3.72092 9.59771 4.14085C9.59771 4.56077 9.25609 4.9024 8.83616 4.9024Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_559_1382",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10.64",
                        height: "10.64",
                        fill: "white",
                        transform: "translate(0.275391 0.128418)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_People = (People);

;// CONCATENATED MODULE: ./src/components/molecules/LivescoreMatchAds/LivescoreMatchAds.tsx


var Ad = function(param) {
    var attributes = param.attributes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "overflow-hidden rounded-xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: attributes.destinationUrl,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        media: "(min-width: 980px)",
                        srcSet: attributes.desktopImage.data.attributes.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: attributes.mobileImage.data.attributes.alternativeText,
                        src: attributes.mobileImage.data.attributes.url
                    })
                ]
            })
        })
    });
};
var LivescoreMatchAds = function() {
    var ref, ref1;
    var ads = useLivescoreMatch().ads;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "sm:text-xxs text-[7px] font-semibold text-gray-400",
                children: "REKLAMA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "list-none pl-0",
                children: (ref2 = (ref1 = ads === null || ads === void 0 ? void 0 : (ref = ads.data) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
                    return b.attributes.order - a.attributes.order;
                })) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                    var id = param.id, attributes = param.attributes;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Ad, {
                        attributes: attributes
                    }, id);
                })) !== null && ref2 !== void 0 ? ref2 : null
            })
        ]
    });
};
/* harmony default export */ var LivescoreMatchAds_LivescoreMatchAds = (LivescoreMatchAds);

;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/solid/esm/SparklesIcon.js

function SparklesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z",
    clipRule: "evenodd"
  }));
}
const SparklesIcon_ForwardRef = /*#__PURE__*/ react.forwardRef(SparklesIcon);
/* harmony default export */ var esm_SparklesIcon = (SparklesIcon_ForwardRef);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreMatchDetails/LivescoreMatchDetails.tsx







var lorem = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
var LivescoreMatchDetails = function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = useLivescoreMatch(), match = ref5.match, matchPreview = ref5.matchPreview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-black dark:text-white space-y-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xxs font-semibold text-gray-400",
                        children: "ZAPOWIEDŹ"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rounded-lg dark:bg-black-400 bg-white_theme-50 px-5 py-3.5",
                        children: (matchPreview === null || matchPreview === void 0 ? void 0 : matchPreview.step) === "fetching" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            className: "w-full h-2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            className: "w-2/3 h-2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            className: "w-1/3 h-2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            className: "w-full h-2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            className: "w-2/3 h-2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            className: "w-1/3 h-2"
                                        })
                                    ]
                                })
                            ]
                        }) : (matchPreview === null || matchPreview === void 0 ? void 0 : matchPreview.step) === "generating preview" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-1 py-4 uppercase font-semibold w-full justify-center animate-pulse text-gray-400",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_SparklesIcon, {
                                    className: "w-5 h-5"
                                }),
                                "Wczytywanie Zapowiedzi"
                            ]
                        }) : (matchPreview === null || matchPreview === void 0 ? void 0 : matchPreview.step) === "error" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-center py-6 text-red-600 w-full font-medium text-xs uppercase",
                            children: "Nie udało się wygenerować zapowiedzi"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "space-y-2",
                            children: matchPreview === null || matchPreview === void 0 ? void 0 : (ref = matchPreview.preview) === null || ref === void 0 ? void 0 : ref.preview.split("\n").map(function(p) {
                                if (p === "\n") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {});
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[11px]",
                                    children: p
                                });
                            })
                        })
                    })
                ]
            }),
            match.sport_event.venue && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xxs font-semibold text-gray-400",
                        children: "INFORMACJE O SPOTKANIU"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "rounded-lg dark:bg-black-400 bg-white_theme-50 px-5 py-3.5 list-disc space-y-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "w-full flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-2 text-[11px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Location, {}),
                                            " Stadion"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-[11px] font-semibold",
                                        children: [
                                            (ref1 = match.sport_event.venue) === null || ref1 === void 0 ? void 0 : ref1.name,
                                            " (",
                                            (ref2 = match.sport_event.venue) === null || ref2 === void 0 ? void 0 : ref2.city_name,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "w-full flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-2 text-[11px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_People, {}),
                                            " Pojemność"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[11px] font-semibold",
                                        children: (ref3 = match.sport_event.venue) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.capacity) === null || ref4 === void 0 ? void 0 : ref4.toLocaleString("pl-PL")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchAds_LivescoreMatchAds, {})
        ]
    });
};
/* harmony default export */ var LivescoreMatchDetails_LivescoreMatchDetails = (LivescoreMatchDetails);

// EXTERNAL MODULE: ./src/components/icons/Goal.tsx
var Goal = __webpack_require__(18137);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreMatchReportItem/LivescoreMatchReportItem.tsx




var SUPPORTED_TYPES = [
    "score_change",
    "yellow_card",
    "red_card"
];
var EventIcon = function(param) {
    var type = param.type;
    switch(type){
        case "score_change":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Goal/* default */.Z, {
                className: "sm:w-3.5 w-2"
            });
        case "yellow_card":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-[#F2D30B] sm:w-[11px] w-2 sm:h-3.5 h-2.5 rounded-[2.66px]",
                "aria-hidden": true
            });
        case "red_card":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-[#F20B0F] sm:w-[11px] w-2 sm:h-3.5 h-2.5 rounded-[2.66px]",
                "aria-hidden": true
            });
        default:
            return null;
    }
};
var LivescoreMatchReportItem = function(param) {
    var event = param.event;
    var ref, ref1, ref2, ref3, ref4;
    if (!SUPPORTED_TYPES.includes(event.type)) {
        return null;
    }
    var match = useLivescoreMatch().match;
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (0,cn.cn)("flex items-center sm:h-10 h-7 px-5 dark:even:bg-black-500 even:bg-white_theme-100 w-full first:rounded-t-lg last:rounded-b-lg", event.competitor === "away" && "flex-row-reverse"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (0,cn.cn)("sm:w-10 w-6 font-bold sm:text-[12px] text-[9px]", event.competitor === "away" && "text-right"),
                children: event.match_time ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        event.match_time,
                        "’"
                    ]
                }) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,cn.cn)("flex items-center gap-1.5", event.competitor === "away" && "flex-row-reverse"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventIcon, {
                        type: event.type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "sm:text-[12px] text-[9px] font-medium",
                        children: (ref5 = (ref = event.players) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref5 !== void 0 ? ref5 : match.sport_event.competitors[event.competitor === "home" ? 0 : 1].name
                    }),
                    !((ref2 = event.players) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "sm:text-[12px] text-[9px] font-medium text-gray-400",
                        children: "(Nieznany zawodnik)"
                    }),
                    ((ref4 = event.players) === null || ref4 === void 0 ? void 0 : ref4[1]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "sm:text-[12px] text-[9px] font-medium text-gray-400",
                        children: [
                            "(",
                            event.players[1].name,
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LivescoreMatchReportItem_LivescoreMatchReportItem = (LivescoreMatchReportItem);

;// CONCATENATED MODULE: ./src/components/molecules/LivescoreMatchReport/LivescoreMatchRaport.tsx





var SkeletonRaport = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "w-26 h-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "w-full h-[160px]"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "w-26 h-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "w-full h-[160px]"
                    })
                ]
            })
        ]
    });
};
var HalfRaport = function(param) {
    var index = param.index;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = useLivescoreMatch(), match = ref7.match, timeline = ref7.timeline;
    var ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex justify-between sm:text-xxs text-[7px] font-semibold text-gray-400",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            index === 1 ? "PIERWSZA" : "DRUGA",
                            " POŁOWA"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            (ref8 = match === null || match === void 0 ? void 0 : (ref = match.sport_event_status) === null || ref === void 0 ? void 0 : (ref1 = ref.period_scores) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[index - 1]) === null || ref2 === void 0 ? void 0 : ref2.home_score) !== null && ref8 !== void 0 ? ref8 : "-",
                            ":",
                            (ref9 = match === null || match === void 0 ? void 0 : (ref3 = match.sport_event_status) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.period_scores) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[index - 1]) === null || ref5 === void 0 ? void 0 : ref5.away_score) !== null && ref9 !== void 0 ? ref9 : "-"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "text-black dark:text-white rounded-lg dark:bg-black-400 bg-white_theme-50 pl-0 border dark:border-border-400 border-gray-250 list-none min-h-[40px]",
                children: (ref6 = timeline === null || timeline === void 0 ? void 0 : timeline.filter(function(event) {
                    return event.period === index;
                })) === null || ref6 === void 0 ? void 0 : ref6.map(function(event) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchReportItem_LivescoreMatchReportItem, {
                        event: event
                    }, event.id);
                })
            })
        ]
    });
};
var LivescoreMatchRaport = function() {
    var ref = useLivescoreMatch(), timeline = ref.timeline, timelineLoading = ref.timelineLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-6",
        children: [
            timelineLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonRaport, {}) : timeline ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HalfRaport, {
                        index: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HalfRaport, {
                        index: 2
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-xxs text-gray-400",
                children: "Brak relacji dla tego meczu"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchAds_LivescoreMatchAds, {})
        ]
    });
};
/* harmony default export */ var LivescoreMatchReport_LivescoreMatchRaport = (LivescoreMatchRaport);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/utils/xG.ts
var xG_SUPPORTED_TYPES = [
    "shot_on_target",
    "shot_off_target",
    "score_change"
];
function calculateSingleShotXG(x, y) {
    var goalPostY1 = 50 - 10.8 / 2; // ~44.6
    var goalPostY2 = 50 + 10.8 / 2; // ~55.4
    // Calculating range to goalposts
    var distA = Math.sqrt(Math.pow(x, 2) + Math.pow(y - goalPostY1, 2));
    var distB = Math.sqrt(Math.pow(x, 2) + Math.pow(y - goalPostY2, 2));
    // Using cosine rule to calculate angle to goal
    // angle = arccos((a^2 + b^2 - c^2) / 2ab)
    var angleRad = Math.acos((distA * distA + distB * distB - 10.8 * 10.8) / (2 * distA * distB));
    // Calculating distance from center of goal line
    var distance = Math.sqrt(x * x + Math.pow(y - 50, 2));
    // Simple logistic regression model: z = intercept + coeff_dist * dist + coeff_angle * angle
    // Coefficients chosen empirically for reasonable results
    var intercept = -1.5;
    var distanceCoefficient = -0.08;
    var angleCoefficient = 1.0;
    var z = intercept + distanceCoefficient * distance + angleCoefficient * angleRad;
    // Sigmoid function (logistic) to convert 'z' to probability (0-1)
    var xg = 1 / (1 + Math.exp(-z));
    return xg;
}
function calculateXG(events, team) {
    if (!events || events.length === 0) {
        return null;
    }
    var shotEvents = events.filter(function(event) {
        return xG_SUPPORTED_TYPES.includes(event.type) && event.competitor === team && typeof event.x === "number" && typeof event.y === "number";
    });
    // Calculating xG for each shot and summing the values
    var totalXG = shotEvents.reduce(function(acc, event) {
        // Normalizing coordinates, so 'x' always means distance from goal line
        // Home team attacks at x=100, so distance is 100 - event.x
        // Away team attacks at x=0, so distance is simply event.x
        var normalizedX = team === "home" ? 100 - event.x : event.x;
        var normalizedY = event.y;
        // Adding xG of single shot to accumulator
        return acc + calculateSingleShotXG(normalizedX, normalizedY);
    }, 0); // Starting summing from 0
    // Returning result rounded to 2 decimal places
    return parseFloat(totalXG.toFixed(2));
}

;// CONCATENATED MODULE: ./src/components/molecules/LivescoreMatchStatistics/LivescoreMatchStatistics.tsx







var Bar = function(param) {
    var percent = param.percent, team = param.team, isWinning = param.isWinning, animate = param.animate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "rounded-[13px] overflow-hidden dark:bg-black-400 bg-white_theme-100 relative w-full h-1.5",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,cn.cn)("absolute h-full transition-all duration-500 ease-out", team === "home" ? isWinning ? "bg-[#53F293]" : "bg-[#53F293]/40" : isWinning ? "bg-[#6960EE]" : "bg-[#6960EE]/40"),
            style: (0,_define_property/* default */.Z)({
                width: animate ? "".concat(percent, "%") : "0%"
            }, team === "home" ? "right" : "left", 0)
        })
    });
};
var _customPercent, _customPercent1;
var StatisticBar = function(param) {
    var title = param.title, loading = param.loading, noValue = param.noValue, values = param.values, animate = param.animate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-black dark:text-white space-y-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-end justify-between",
                children: [
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "w-2 h-4"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-semibold sm:text-[13px] text-[10px]",
                        children: noValue ? "-" : values.home.displayValue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "sm:text-[12px] text-[9px] font-medium mb-1",
                        children: title
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "w-2 h-4"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-semibold sm:text-[13px] text-[10px]",
                        children: noValue ? "-" : values.away.displayValue
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex gap-6",
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-6 w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            className: "w-full h-1.5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            className: "w-full h-1.5"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
                            percent: noValue ? 0 : (_customPercent = values.home.customPercent) !== null && _customPercent !== void 0 ? _customPercent : values.home.value * 100 / (values.home.value + values.away.value),
                            team: "home",
                            isWinning: values.home.value > values.away.value,
                            animate: animate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
                            percent: noValue ? 0 : (_customPercent1 = values.away.customPercent) !== null && _customPercent1 !== void 0 ? _customPercent1 : values.away.value * 100 / (values.home.value + values.away.value),
                            team: "away",
                            isWinning: values.away.value > values.home.value,
                            animate: animate
                        })
                    ]
                })
            })
        ]
    });
};
var LivescoreMatchStatistics = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79, ref80, ref81, ref82, ref83, ref84, ref85, ref86, ref87, ref88, ref89, ref90, ref91, ref92, ref93, ref94, ref95, ref96, ref97, ref98, ref99, ref100, ref101, ref102, ref103, ref104, ref105, ref106, ref107, ref108, ref109, ref110, ref111, ref112, ref113, ref114, ref115, ref116, ref117, ref118, ref119, ref120, ref121, ref122, ref123, ref124, ref125, ref126, ref127, ref128, ref129, ref130, ref131, ref132, ref133, ref134, ref135, ref136, ref137, ref138, ref139, ref140, ref141, ref142, ref143, ref144, ref145, ref146, ref147, ref148, ref149, ref150, ref151, ref152, ref153, ref154, ref155, ref156, ref157, ref158, ref159, ref160, ref161, ref162, ref163, ref164, ref165, ref166, ref167, ref168, ref169, ref170, ref171, ref172, ref173, ref174, ref175, ref176, ref177, ref178, ref179, ref180, ref181, ref182, ref183, ref184, ref185, ref186, ref187, ref188, ref189, ref190, ref191, ref192, ref193, ref194, ref195, ref196, ref197, ref198, ref199, ref200, ref201, ref202, ref203, ref204, ref205, ref206, ref207, ref208, ref209, ref210, ref211, ref212, ref213, ref214, ref215, ref216, ref217, ref218, ref219, ref220, ref221, ref222, ref223, ref224, ref225, ref226, ref227, ref228, ref229, ref230, ref231;
    var ref232 = useLivescoreMatch(), match = ref232.match, timeline = ref232.timeline, timelineLoading = ref232.timelineLoading;
    var ref233 = (0,react.useState)(0), homeXG = ref233[0], setHomeXG = ref233[1];
    var ref234 = (0,react.useState)(0), awayXG = ref234[0], setAwayXG = ref234[1];
    var ref235 = (0,react.useState)(false), areStatsReady = ref235[0], setAreStatsReady = ref235[1];
    (0,react.useEffect)(function() {
        if (!timelineLoading && Array.isArray(timeline) && (timeline === null || timeline === void 0 ? void 0 : timeline.length)) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            setAreStatsReady(false);
            var homeTimeline = timeline.filter(function(event) {
                return event.competitor === "home";
            });
            var awayTimeline = timeline.filter(function(event) {
                return event.competitor === "away";
            });
            var homeXGRaw = calculateXG(homeTimeline, "home");
            var awayXGRaw = calculateXG(awayTimeline, "away");
            var homeStats = match === null || match === void 0 ? void 0 : (ref = match.statistics) === null || ref === void 0 ? void 0 : (ref1 = ref.totals) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.competitors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.statistics;
            var awayStats = match === null || match === void 0 ? void 0 : (ref4 = match.statistics) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.totals) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.competitors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[1]) === null || ref7 === void 0 ? void 0 : ref7.statistics;
            var calcQualityFactor = function(stats) {
                if (!stats) return 1;
                var shotAcc = stats.shots_on_target && stats.shots_total ? stats.shots_on_target / stats.shots_total : 0.5;
                var possession = stats.ball_possession != null ? stats.ball_possession / 100 : 0.5;
                var passAcc = stats.passes_successful && stats.passes_total ? stats.passes_successful / stats.passes_total : 0.5;
                return shotAcc * 0.35 + possession * 0.65 + passAcc * 0.15;
            };
            var homeAccuracy = calcQualityFactor(homeStats);
            var awayAccuracy = calcQualityFactor(awayStats);
            if (homeXGRaw !== null) setHomeXG(parseFloat((homeXGRaw * homeAccuracy).toFixed(2)));
            if (awayXGRaw !== null) setAwayXG(parseFloat((awayXGRaw * awayAccuracy).toFixed(2)));
            setAreStatsReady(true);
        }
    }, [
        timeline
    ]);
    if (!((ref = match.statistics) === null || ref === void 0 ? void 0 : (ref1 = ref.totals) === null || ref1 === void 0 ? void 0 : ref1.competitors)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "text-xxs text-gray-400",
            children: "Brak statystyk dla tego meczu"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "list-none pl-0 sm:space-y-6 space-y-4 py-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatisticBar, {
                    title: "Oczekiwane gole (xG)",
                    values: {
                        home: {
                            displayValue: homeXG.toFixed(2),
                            value: homeXG
                        },
                        away: {
                            displayValue: awayXG.toFixed(2),
                            value: awayXG
                        }
                    },
                    loading: timelineLoading,
                    noValue: !timelineLoading && (!Array.isArray(timeline) || !(timeline === null || timeline === void 0 ? void 0 : timeline.length)),
                    animate: areStatsReady
                })
            }),
            (match === null || match === void 0 ? void 0 : (ref2 = match.statistics) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.totals) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.competitors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.statistics) === null || ref6 === void 0 ? void 0 : ref6.ball_possession) && (match === null || match === void 0 ? void 0 : (ref7 = match.statistics) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.totals) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.competitors) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[1]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.statistics) === null || ref11 === void 0 ? void 0 : ref11.ball_possession) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatisticBar, {
                    title: "Posiadanie piłki",
                    values: {
                        home: {
                            displayValue: "".concat(match === null || match === void 0 ? void 0 : (ref12 = match.statistics) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.totals) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.competitors) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.statistics) === null || ref16 === void 0 ? void 0 : ref16.ball_possession, "%"),
                            value: match === null || match === void 0 ? void 0 : (ref17 = match.statistics) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.totals) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.competitors) === null || ref19 === void 0 ? void 0 : (ref20 = ref19[0]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.statistics) === null || ref21 === void 0 ? void 0 : ref21.ball_possession
                        },
                        away: {
                            displayValue: "".concat(match === null || match === void 0 ? void 0 : (ref22 = match.statistics) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.totals) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.competitors) === null || ref24 === void 0 ? void 0 : (ref25 = ref24[1]) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.statistics) === null || ref26 === void 0 ? void 0 : ref26.ball_possession, "%"),
                            value: match === null || match === void 0 ? void 0 : (ref27 = match.statistics) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.totals) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.competitors) === null || ref29 === void 0 ? void 0 : (ref30 = ref29[1]) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.statistics) === null || ref31 === void 0 ? void 0 : ref31.ball_possession
                        }
                    },
                    animate: areStatsReady
                })
            }) : null,
            (match === null || match === void 0 ? void 0 : (ref32 = match.statistics) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.totals) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.competitors) === null || ref34 === void 0 ? void 0 : (ref35 = ref34[0]) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.statistics) === null || ref36 === void 0 ? void 0 : ref36.shots_total) && (match === null || match === void 0 ? void 0 : (ref37 = match.statistics) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.totals) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.competitors) === null || ref39 === void 0 ? void 0 : (ref40 = ref39[1]) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.statistics) === null || ref41 === void 0 ? void 0 : ref41.shots_total) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatisticBar, {
                    title: "Strzały Łącznie",
                    values: {
                        home: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref42 = match.statistics) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.totals) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.competitors) === null || ref44 === void 0 ? void 0 : (ref45 = ref44[0]) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.statistics) === null || ref46 === void 0 ? void 0 : ref46.shots_total.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref47 = match.statistics) === null || ref47 === void 0 ? void 0 : (ref48 = ref47.totals) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.competitors) === null || ref49 === void 0 ? void 0 : (ref50 = ref49[0]) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.statistics) === null || ref51 === void 0 ? void 0 : ref51.shots_total
                        },
                        away: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref52 = match.statistics) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.totals) === null || ref53 === void 0 ? void 0 : (ref54 = ref53.competitors) === null || ref54 === void 0 ? void 0 : (ref55 = ref54[1]) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.statistics) === null || ref56 === void 0 ? void 0 : ref56.shots_total.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref57 = match.statistics) === null || ref57 === void 0 ? void 0 : (ref58 = ref57.totals) === null || ref58 === void 0 ? void 0 : (ref59 = ref58.competitors) === null || ref59 === void 0 ? void 0 : (ref60 = ref59[1]) === null || ref60 === void 0 ? void 0 : (ref61 = ref60.statistics) === null || ref61 === void 0 ? void 0 : ref61.shots_total
                        }
                    },
                    animate: areStatsReady
                })
            }) : null,
            (match === null || match === void 0 ? void 0 : (ref62 = match.statistics) === null || ref62 === void 0 ? void 0 : (ref63 = ref62.totals) === null || ref63 === void 0 ? void 0 : (ref64 = ref63.competitors) === null || ref64 === void 0 ? void 0 : (ref65 = ref64[0]) === null || ref65 === void 0 ? void 0 : (ref66 = ref65.statistics) === null || ref66 === void 0 ? void 0 : ref66.shots_on_target) && (match === null || match === void 0 ? void 0 : (ref67 = match.statistics) === null || ref67 === void 0 ? void 0 : (ref68 = ref67.totals) === null || ref68 === void 0 ? void 0 : (ref69 = ref68.competitors) === null || ref69 === void 0 ? void 0 : (ref70 = ref69[1]) === null || ref70 === void 0 ? void 0 : (ref71 = ref70.statistics) === null || ref71 === void 0 ? void 0 : ref71.shots_on_target) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatisticBar, {
                    title: "Strzały Celne",
                    values: {
                        home: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref72 = match.statistics) === null || ref72 === void 0 ? void 0 : (ref73 = ref72.totals) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.competitors) === null || ref74 === void 0 ? void 0 : (ref75 = ref74[0]) === null || ref75 === void 0 ? void 0 : (ref76 = ref75.statistics) === null || ref76 === void 0 ? void 0 : ref76.shots_on_target.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref77 = match.statistics) === null || ref77 === void 0 ? void 0 : (ref78 = ref77.totals) === null || ref78 === void 0 ? void 0 : (ref79 = ref78.competitors) === null || ref79 === void 0 ? void 0 : (ref80 = ref79[0]) === null || ref80 === void 0 ? void 0 : (ref81 = ref80.statistics) === null || ref81 === void 0 ? void 0 : ref81.shots_on_target
                        },
                        away: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref82 = match.statistics) === null || ref82 === void 0 ? void 0 : (ref83 = ref82.totals) === null || ref83 === void 0 ? void 0 : (ref84 = ref83.competitors) === null || ref84 === void 0 ? void 0 : (ref85 = ref84[1]) === null || ref85 === void 0 ? void 0 : (ref86 = ref85.statistics) === null || ref86 === void 0 ? void 0 : ref86.shots_on_target.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref87 = match.statistics) === null || ref87 === void 0 ? void 0 : (ref88 = ref87.totals) === null || ref88 === void 0 ? void 0 : (ref89 = ref88.competitors) === null || ref89 === void 0 ? void 0 : (ref90 = ref89[1]) === null || ref90 === void 0 ? void 0 : (ref91 = ref90.statistics) === null || ref91 === void 0 ? void 0 : ref91.shots_on_target
                        }
                    },
                    animate: areStatsReady
                })
            }) : null,
            (match === null || match === void 0 ? void 0 : (ref92 = match.statistics) === null || ref92 === void 0 ? void 0 : (ref93 = ref92.totals) === null || ref93 === void 0 ? void 0 : (ref94 = ref93.competitors) === null || ref94 === void 0 ? void 0 : (ref95 = ref94[0]) === null || ref95 === void 0 ? void 0 : (ref96 = ref95.statistics) === null || ref96 === void 0 ? void 0 : ref96.corner_kicks) && (match === null || match === void 0 ? void 0 : (ref97 = match.statistics) === null || ref97 === void 0 ? void 0 : (ref98 = ref97.totals) === null || ref98 === void 0 ? void 0 : (ref99 = ref98.competitors) === null || ref99 === void 0 ? void 0 : (ref100 = ref99[1]) === null || ref100 === void 0 ? void 0 : (ref101 = ref100.statistics) === null || ref101 === void 0 ? void 0 : ref101.corner_kicks) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatisticBar, {
                    title: "Rzuty rożne",
                    values: {
                        home: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref102 = match.statistics) === null || ref102 === void 0 ? void 0 : (ref103 = ref102.totals) === null || ref103 === void 0 ? void 0 : (ref104 = ref103.competitors) === null || ref104 === void 0 ? void 0 : (ref105 = ref104[0]) === null || ref105 === void 0 ? void 0 : (ref106 = ref105.statistics) === null || ref106 === void 0 ? void 0 : ref106.corner_kicks.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref107 = match.statistics) === null || ref107 === void 0 ? void 0 : (ref108 = ref107.totals) === null || ref108 === void 0 ? void 0 : (ref109 = ref108.competitors) === null || ref109 === void 0 ? void 0 : (ref110 = ref109[0]) === null || ref110 === void 0 ? void 0 : (ref111 = ref110.statistics) === null || ref111 === void 0 ? void 0 : ref111.corner_kicks
                        },
                        away: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref112 = match.statistics) === null || ref112 === void 0 ? void 0 : (ref113 = ref112.totals) === null || ref113 === void 0 ? void 0 : (ref114 = ref113.competitors) === null || ref114 === void 0 ? void 0 : (ref115 = ref114[1]) === null || ref115 === void 0 ? void 0 : (ref116 = ref115.statistics) === null || ref116 === void 0 ? void 0 : ref116.corner_kicks.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref117 = match.statistics) === null || ref117 === void 0 ? void 0 : (ref118 = ref117.totals) === null || ref118 === void 0 ? void 0 : (ref119 = ref118.competitors) === null || ref119 === void 0 ? void 0 : (ref120 = ref119[1]) === null || ref120 === void 0 ? void 0 : (ref121 = ref120.statistics) === null || ref121 === void 0 ? void 0 : ref121.corner_kicks
                        }
                    },
                    animate: areStatsReady
                })
            }) : null,
            (match === null || match === void 0 ? void 0 : (ref122 = match.statistics) === null || ref122 === void 0 ? void 0 : (ref123 = ref122.totals) === null || ref123 === void 0 ? void 0 : (ref124 = ref123.competitors) === null || ref124 === void 0 ? void 0 : (ref125 = ref124[0]) === null || ref125 === void 0 ? void 0 : (ref126 = ref125.statistics) === null || ref126 === void 0 ? void 0 : ref126.passes_total) && (match === null || match === void 0 ? void 0 : (ref127 = match.statistics) === null || ref127 === void 0 ? void 0 : (ref128 = ref127.totals) === null || ref128 === void 0 ? void 0 : (ref129 = ref128.competitors) === null || ref129 === void 0 ? void 0 : (ref130 = ref129[1]) === null || ref130 === void 0 ? void 0 : (ref131 = ref130.statistics) === null || ref131 === void 0 ? void 0 : ref131.passes_total) && (match === null || match === void 0 ? void 0 : (ref132 = match.statistics) === null || ref132 === void 0 ? void 0 : (ref133 = ref132.totals) === null || ref133 === void 0 ? void 0 : (ref134 = ref133.competitors) === null || ref134 === void 0 ? void 0 : (ref135 = ref134[0]) === null || ref135 === void 0 ? void 0 : (ref136 = ref135.statistics) === null || ref136 === void 0 ? void 0 : ref136.passes_unsuccessful) && (match === null || match === void 0 ? void 0 : (ref137 = match.statistics) === null || ref137 === void 0 ? void 0 : (ref138 = ref137.totals) === null || ref138 === void 0 ? void 0 : (ref139 = ref138.competitors) === null || ref139 === void 0 ? void 0 : (ref140 = ref139[1]) === null || ref140 === void 0 ? void 0 : (ref141 = ref140.statistics) === null || ref141 === void 0 ? void 0 : ref141.passes_unsuccessful) ? function() {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
                var shotsAccuracyHome = ((match === null || match === void 0 ? void 0 : (ref = match.statistics) === null || ref === void 0 ? void 0 : (ref1 = ref.totals) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.competitors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.statistics) === null || ref4 === void 0 ? void 0 : ref4.passes_total) - (match === null || match === void 0 ? void 0 : (ref5 = match.statistics) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.totals) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.competitors) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.statistics) === null || ref9 === void 0 ? void 0 : ref9.passes_unsuccessful)) / (match === null || match === void 0 ? void 0 : (ref10 = match.statistics) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.totals) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.competitors) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.statistics) === null || ref14 === void 0 ? void 0 : ref14.passes_total) * 100;
                var shotsAccuracyAway = ((match === null || match === void 0 ? void 0 : (ref15 = match.statistics) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.totals) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.competitors) === null || ref17 === void 0 ? void 0 : (ref18 = ref17[1]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.statistics) === null || ref19 === void 0 ? void 0 : ref19.passes_total) - (match === null || match === void 0 ? void 0 : (ref20 = match.statistics) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.totals) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.competitors) === null || ref22 === void 0 ? void 0 : (ref23 = ref22[1]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.statistics) === null || ref24 === void 0 ? void 0 : ref24.passes_unsuccessful)) / (match === null || match === void 0 ? void 0 : (ref25 = match.statistics) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.totals) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.competitors) === null || ref27 === void 0 ? void 0 : (ref28 = ref27[1]) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.statistics) === null || ref29 === void 0 ? void 0 : ref29.passes_total) * 100;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatisticBar, {
                        title: "Celność podań",
                        values: {
                            home: {
                                displayValue: shotsAccuracyHome.toFixed(0) + "%",
                                value: shotsAccuracyHome,
                                customPercent: shotsAccuracyHome
                            },
                            away: {
                                displayValue: shotsAccuracyAway.toFixed(0) + "%",
                                value: shotsAccuracyAway,
                                customPercent: shotsAccuracyAway
                            }
                        },
                        animate: areStatsReady
                    })
                });
            }() : null,
            (match === null || match === void 0 ? void 0 : (ref142 = match.statistics) === null || ref142 === void 0 ? void 0 : (ref143 = ref142.totals) === null || ref143 === void 0 ? void 0 : (ref144 = ref143.competitors) === null || ref144 === void 0 ? void 0 : (ref145 = ref144[0]) === null || ref145 === void 0 ? void 0 : (ref146 = ref145.statistics) === null || ref146 === void 0 ? void 0 : ref146.yellow_cards) && (match === null || match === void 0 ? void 0 : (ref147 = match.statistics) === null || ref147 === void 0 ? void 0 : (ref148 = ref147.totals) === null || ref148 === void 0 ? void 0 : (ref149 = ref148.competitors) === null || ref149 === void 0 ? void 0 : (ref150 = ref149[1]) === null || ref150 === void 0 ? void 0 : (ref151 = ref150.statistics) === null || ref151 === void 0 ? void 0 : ref151.yellow_cards) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatisticBar, {
                    title: "Ż\xf3łte kartki",
                    values: {
                        home: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref152 = match.statistics) === null || ref152 === void 0 ? void 0 : (ref153 = ref152.totals) === null || ref153 === void 0 ? void 0 : (ref154 = ref153.competitors) === null || ref154 === void 0 ? void 0 : (ref155 = ref154[0]) === null || ref155 === void 0 ? void 0 : (ref156 = ref155.statistics) === null || ref156 === void 0 ? void 0 : ref156.yellow_cards.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref157 = match.statistics) === null || ref157 === void 0 ? void 0 : (ref158 = ref157.totals) === null || ref158 === void 0 ? void 0 : (ref159 = ref158.competitors) === null || ref159 === void 0 ? void 0 : (ref160 = ref159[0]) === null || ref160 === void 0 ? void 0 : (ref161 = ref160.statistics) === null || ref161 === void 0 ? void 0 : ref161.yellow_cards
                        },
                        away: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref162 = match.statistics) === null || ref162 === void 0 ? void 0 : (ref163 = ref162.totals) === null || ref163 === void 0 ? void 0 : (ref164 = ref163.competitors) === null || ref164 === void 0 ? void 0 : (ref165 = ref164[1]) === null || ref165 === void 0 ? void 0 : (ref166 = ref165.statistics) === null || ref166 === void 0 ? void 0 : ref166.yellow_cards.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref167 = match.statistics) === null || ref167 === void 0 ? void 0 : (ref168 = ref167.totals) === null || ref168 === void 0 ? void 0 : (ref169 = ref168.competitors) === null || ref169 === void 0 ? void 0 : (ref170 = ref169[1]) === null || ref170 === void 0 ? void 0 : (ref171 = ref170.statistics) === null || ref171 === void 0 ? void 0 : ref171.yellow_cards
                        }
                    },
                    animate: areStatsReady
                })
            }) : null,
            (match === null || match === void 0 ? void 0 : (ref172 = match.statistics) === null || ref172 === void 0 ? void 0 : (ref173 = ref172.totals) === null || ref173 === void 0 ? void 0 : (ref174 = ref173.competitors) === null || ref174 === void 0 ? void 0 : (ref175 = ref174[0]) === null || ref175 === void 0 ? void 0 : (ref176 = ref175.statistics) === null || ref176 === void 0 ? void 0 : ref176.fouls) && (match === null || match === void 0 ? void 0 : (ref177 = match.statistics) === null || ref177 === void 0 ? void 0 : (ref178 = ref177.totals) === null || ref178 === void 0 ? void 0 : (ref179 = ref178.competitors) === null || ref179 === void 0 ? void 0 : (ref180 = ref179[1]) === null || ref180 === void 0 ? void 0 : (ref181 = ref180.statistics) === null || ref181 === void 0 ? void 0 : ref181.fouls) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatisticBar, {
                    title: "Faule",
                    values: {
                        home: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref182 = match.statistics) === null || ref182 === void 0 ? void 0 : (ref183 = ref182.totals) === null || ref183 === void 0 ? void 0 : (ref184 = ref183.competitors) === null || ref184 === void 0 ? void 0 : (ref185 = ref184[0]) === null || ref185 === void 0 ? void 0 : (ref186 = ref185.statistics) === null || ref186 === void 0 ? void 0 : ref186.fouls.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref187 = match.statistics) === null || ref187 === void 0 ? void 0 : (ref188 = ref187.totals) === null || ref188 === void 0 ? void 0 : (ref189 = ref188.competitors) === null || ref189 === void 0 ? void 0 : (ref190 = ref189[0]) === null || ref190 === void 0 ? void 0 : (ref191 = ref190.statistics) === null || ref191 === void 0 ? void 0 : ref191.fouls
                        },
                        away: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref192 = match.statistics) === null || ref192 === void 0 ? void 0 : (ref193 = ref192.totals) === null || ref193 === void 0 ? void 0 : (ref194 = ref193.competitors) === null || ref194 === void 0 ? void 0 : (ref195 = ref194[1]) === null || ref195 === void 0 ? void 0 : (ref196 = ref195.statistics) === null || ref196 === void 0 ? void 0 : ref196.fouls.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref197 = match.statistics) === null || ref197 === void 0 ? void 0 : (ref198 = ref197.totals) === null || ref198 === void 0 ? void 0 : (ref199 = ref198.competitors) === null || ref199 === void 0 ? void 0 : (ref200 = ref199[1]) === null || ref200 === void 0 ? void 0 : (ref201 = ref200.statistics) === null || ref201 === void 0 ? void 0 : ref201.fouls
                        }
                    },
                    animate: areStatsReady
                })
            }) : null,
            (match === null || match === void 0 ? void 0 : (ref202 = match.statistics) === null || ref202 === void 0 ? void 0 : (ref203 = ref202.totals) === null || ref203 === void 0 ? void 0 : (ref204 = ref203.competitors) === null || ref204 === void 0 ? void 0 : (ref205 = ref204[0]) === null || ref205 === void 0 ? void 0 : (ref206 = ref205.statistics) === null || ref206 === void 0 ? void 0 : ref206.offsides) && (match === null || match === void 0 ? void 0 : (ref207 = match.statistics) === null || ref207 === void 0 ? void 0 : (ref208 = ref207.totals) === null || ref208 === void 0 ? void 0 : (ref209 = ref208.competitors) === null || ref209 === void 0 ? void 0 : (ref210 = ref209[1]) === null || ref210 === void 0 ? void 0 : (ref211 = ref210.statistics) === null || ref211 === void 0 ? void 0 : ref211.offsides) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatisticBar, {
                    title: "Spalone",
                    values: {
                        home: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref212 = match.statistics) === null || ref212 === void 0 ? void 0 : (ref213 = ref212.totals) === null || ref213 === void 0 ? void 0 : (ref214 = ref213.competitors) === null || ref214 === void 0 ? void 0 : (ref215 = ref214[0]) === null || ref215 === void 0 ? void 0 : (ref216 = ref215.statistics) === null || ref216 === void 0 ? void 0 : ref216.offsides.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref217 = match.statistics) === null || ref217 === void 0 ? void 0 : (ref218 = ref217.totals) === null || ref218 === void 0 ? void 0 : (ref219 = ref218.competitors) === null || ref219 === void 0 ? void 0 : (ref220 = ref219[0]) === null || ref220 === void 0 ? void 0 : (ref221 = ref220.statistics) === null || ref221 === void 0 ? void 0 : ref221.offsides
                        },
                        away: {
                            displayValue: match === null || match === void 0 ? void 0 : (ref222 = match.statistics) === null || ref222 === void 0 ? void 0 : (ref223 = ref222.totals) === null || ref223 === void 0 ? void 0 : (ref224 = ref223.competitors) === null || ref224 === void 0 ? void 0 : (ref225 = ref224[1]) === null || ref225 === void 0 ? void 0 : (ref226 = ref225.statistics) === null || ref226 === void 0 ? void 0 : ref226.offsides.toString(),
                            value: match === null || match === void 0 ? void 0 : (ref227 = match.statistics) === null || ref227 === void 0 ? void 0 : (ref228 = ref227.totals) === null || ref228 === void 0 ? void 0 : (ref229 = ref228.competitors) === null || ref229 === void 0 ? void 0 : (ref230 = ref229[1]) === null || ref230 === void 0 ? void 0 : (ref231 = ref230.statistics) === null || ref231 === void 0 ? void 0 : ref231.offsides
                        }
                    },
                    animate: areStatsReady
                })
            }) : null
        ]
    });
};
/* harmony default export */ var LivescoreMatchStatistics_LivescoreMatchStatistics = (LivescoreMatchStatistics);

// EXTERNAL MODULE: ./src/components/molecules/LivescoreSeasonTable/LivescoreSeasonTable.tsx + 2 modules
var LivescoreSeasonTable = __webpack_require__(59781);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/atoms/LivescorePlayerStats/LivescorePlayerStats.tsx
var LivescorePlayerStats = __webpack_require__(62174);
;// CONCATENATED MODULE: ./src/components/icons/Substitution.tsx


var Substitution = function(param) {
    var className = param.className, width = param.width, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 7 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_922_36605)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.89306 2.37012H1.45965L0 4.00163L1.45145 5.85574H1.89306V4.83055H4.69687V3.3953H1.89306V2.37012Z",
                        fill: "#FF0004"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.54851 0.524902H5.10691V1.55008H2.3031V2.98534H5.10691V4.01052H5.54031L6.99997 2.37902L5.54851 0.524902Z",
                        fill: "#06C000"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_922_36605",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "7",
                        height: "7",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_Substitution = (Substitution);

// EXTERNAL MODULE: ./src/hooks/useWindowResize.tsx
var useWindowResize = __webpack_require__(48508);
;// CONCATENATED MODULE: ./src/components/molecules/LivesoreFormationDetails/subcomponents/Substitutions.tsx









var SubstitiutionItem = function(param) {
    var sub = param.sub, reverse = param.reverse;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var match = useLivescoreMatch().match;
    var width = (0,useWindowResize/* useWindowSize */.i)().width;
    var timeDiff = new Date(sub.time).getTime() - new Date(match.sport_event.start_time || 0).getTime();
    var minutes = Math.floor(timeDiff / 60000);
    var _img, ref9, _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (0,cn.cn)("flex items-center gap-2", reverse ? "flex-row-reverse" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[28px] h-[28px] sm:w-[30px] sm:h-[30px] relative rounded-full overflow-hidden mb-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (_img = sub.to.img) !== null && _img !== void 0 ? _img : "/images/player.png",
                    alt: sub.to.name,
                    layout: "fill",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-1 sm:space-y-0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LivescoreEntityLink/* default */.Z, {
                        href: "/livescore/player/".concat(sub.to.slug ? sub.to.slug : sub === null || sub === void 0 ? void 0 : (ref = sub.to) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.split(":")[2]),
                        className: (0,cn.cn)("flex items-center gap-2", reverse ? "flex-row-reverse" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[7px] sm:text-xxs",
                                children: sub.to.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescorePlayerStats/* default */.Z, {
                                stats: (ref9 = (ref6 = (ref5 = (ref2 = match.statistics) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.totals) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.competitors) === null || ref4 === void 0 ? void 0 : ref4.find(function(c) {
                                    return c.qualifier === "home";
                                })) === null || ref5 === void 0 ? void 0 : ref5.players.find(function(p) {
                                    return p.id === sub.to.id;
                                })) === null || ref6 === void 0 ? void 0 : ref6.statistics) !== null && ref9 !== void 0 ? ref9 : {},
                                position: (_type = sub.to.type) !== null && _type !== void 0 ? _type : "",
                                className: "text-[6px] sm:text-[9px] !text-white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LivescoreEntityLink/* default */.Z, {
                        href: "/livescore/player/".concat(sub.from.slug ? sub.from.slug : sub === null || sub === void 0 ? void 0 : (ref7 = sub.from) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.id) === null || ref8 === void 0 ? void 0 : ref8.split(":")[2]),
                        className: (0,cn.cn)("flex items-center gap-1", reverse ? "flex-row-reverse" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Substitution, {
                                width: width ? width > 600 ? 12 : 7 : 7,
                                height: width ? width > 600 ? 10 : 5.33 : 5.33
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[7px] font-semibold sm:text-xxs",
                                children: sub.from.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "dark:bg-black-500 bg-white rounded border dark:border-border-400 border-gray-250 px-[3px] py-[1px] sm:px-1 sm:py-0.5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-[7px] sm:text-[8px] font-semibold",
                                    children: [
                                        minutes > 45 ? minutes - 15 : minutes,
                                        "’"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Substitutions = function() {
    var ref, ref1;
    var ref2 = useLivescoreMatch(), match = ref2.match, substitutions = ref2.substitutions;
    if (!(substitutions === null || substitutions === void 0 ? void 0 : substitutions.home.length) && !(substitutions === null || substitutions === void 0 ? void 0 : substitutions.away.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-black dark:text-white font-semibold text-xs mb-2.5",
                children: "Zmienieni zawodnicy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between dark:bg-black-400 bg-white_theme-50 text-black dark:text-white rounded-md mt-2 px-2 sm:px-5 py-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "font-semibold text-xxs sm:text-xs mb-2",
                                children: (ref = match.sport_event.competitors.find(function(c) {
                                    return c.qualifier === "home";
                                })) === null || ref === void 0 ? void 0 : ref.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "space-y-3 pl-0",
                                children: substitutions === null || substitutions === void 0 ? void 0 : substitutions.home.map(function(substitution) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubstitiutionItem, {
                                        sub: substitution
                                    }, substitution.to.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "font-semibold text-xxs sm:text-xs mb-2",
                                children: (ref1 = match.sport_event.competitors.find(function(c) {
                                    return c.qualifier === "away";
                                })) === null || ref1 === void 0 ? void 0 : ref1.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "flex flex-col items-end space-y-3 pl-0",
                                children: substitutions === null || substitutions === void 0 ? void 0 : substitutions.away.map(function(substitution) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubstitiutionItem, {
                                        sub: substitution,
                                        reverse: true
                                    }, substitution.to.id);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var subcomponents_Substitutions = (Substitutions);

;// CONCATENATED MODULE: ./src/components/molecules/LivesoreFormationDetails/subcomponents/Starters.tsx







var StarterItem = function(param) {
    var player = param.player, reverse = param.reverse;
    var ref;
    var aplha = player.country_code ? (0,utils_countryCode/* convertAlpha */.Ob)(player.country_code) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LivescoreEntityLink/* default */.Z, {
            href: "/livescore/player/".concat(player.slug ? player.slug : player === null || player === void 0 ? void 0 : (ref = player.id) === null || ref === void 0 ? void 0 : ref.split(":")[2]),
            className: (0,cn.cn)("flex items-center gap-1", reverse ? "flex-row-reverse" : ""),
            children: [
                player.jersey_number ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[8px] sm:text-[11px]",
                    children: player.jersey_number
                }) : null,
                aplha ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[7px] h-[7px] sm:w-[10px] sm:h-[10px] rounded-full relative overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "https://flagcdn.com/".concat(aplha.toLocaleLowerCase(), ".svg"),
                        alt: aplha,
                        layout: "fill",
                        objectFit: "cover"
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[8px] sm:text-[11px] font-semibold",
                    children: player.name
                })
            ]
        })
    });
};
var Starters = function() {
    var starters = useLivescoreMatch().starters;
    if (!(starters === null || starters === void 0 ? void 0 : starters.home.length) && !(starters === null || starters === void 0 ? void 0 : starters.away.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-4 text-black dark:text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "text-xs mb-2.5",
                children: "Składy wyjściowe"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "pl-0 list-none space-y-2 sm:space-y-2.5",
                        children: starters === null || starters === void 0 ? void 0 : starters.home.map(function(player) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StarterItem, {
                                player: player
                            }, player.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "pl-0 list-none space-y-2 sm:space-y-2.5",
                        children: starters === null || starters === void 0 ? void 0 : starters.away.map(function(player) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StarterItem, {
                                player: player,
                                reverse: true
                            }, player.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var subcomponents_Starters = (Starters);

;// CONCATENATED MODULE: ./src/components/molecules/LivesoreFormationDetails/subcomponents/Substitutes.tsx







var SubstitutesItem = function(param) {
    var player = param.player, reverse = param.reverse;
    var ref;
    var aplha = player.country_code ? (0,utils_countryCode/* convertAlpha */.Ob)(player.country_code) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LivescoreEntityLink/* default */.Z, {
            href: "/livescore/player/".concat(player.slug ? player.slug : player === null || player === void 0 ? void 0 : (ref = player.id) === null || ref === void 0 ? void 0 : ref.split(":")[2]),
            className: (0,cn.cn)("flex items-center gap-1", reverse ? "flex-row-reverse" : ""),
            children: [
                player.jersey_number ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[8px] sm:text-[11px]",
                    children: player.jersey_number
                }) : null,
                aplha ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[7px] h-[7px] sm:w-[10px] sm:h-[10px] rounded-full relative overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "https://flagcdn.com/".concat(aplha.toLocaleLowerCase(), ".svg"),
                        alt: aplha,
                        layout: "fill",
                        objectFit: "cover"
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[8px] sm:text-[11px] font-semibold",
                    children: player.name
                })
            ]
        })
    });
};
var Substitutes = function() {
    var substitutes = useLivescoreMatch().substitutes;
    if (!(substitutes === null || substitutes === void 0 ? void 0 : substitutes.home.length) && !(substitutes === null || substitutes === void 0 ? void 0 : substitutes.away.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-4 text-black dark:text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "text-xs mb-2.5",
                children: "Rezerwowi"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "pl-0 list-none space-y-2 sm:space-y-2.5",
                        children: substitutes === null || substitutes === void 0 ? void 0 : substitutes.home.map(function(player) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubstitutesItem, {
                                player: player
                            }, player.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "pl-0 list-none space-y-2 sm:space-y-2.5",
                        children: substitutes === null || substitutes === void 0 ? void 0 : substitutes.away.map(function(player) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubstitutesItem, {
                                player: player,
                                reverse: true
                            }, player.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var subcomponents_Substitutes = (Substitutes);

;// CONCATENATED MODULE: ./src/components/molecules/LivesoreFormationDetails/subcomponents/SubstitutionsSkeleton.tsx



var SubstitutionItemSkeleton = function(param) {
    var _reverse = param.reverse, reverse = _reverse === void 0 ? false : _reverse;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (0,cn.cn)("flex items-center gap-2", reverse ? "flex-row-reverse" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[28px] h-[28px] sm:w-[32px] sm:h-[32px] dark:bg-gray-600 bg-gray-200 rounded-full animate-pulse"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-1 sm:space-y-1.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,cn.cn)("flex items-center gap-2", reverse ? "flex-row-reverse" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2 sm:h-3 w-16 sm:w-20 dark:bg-gray-600 bg-gray-200 rounded animate-pulse"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2 sm:h-3 w-8 sm:w-10 dark:bg-gray-600 bg-gray-200 rounded animate-pulse"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,cn.cn)("flex items-center gap-1", reverse ? "flex-row-reverse" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-3 h-2 sm:w-4 sm:h-3 dark:bg-gray-600 bg-gray-200 rounded animate-pulse"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2 sm:h-3 w-12 sm:w-16 dark:bg-gray-600 bg-gray-200 rounded animate-pulse"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 sm:h-5 w-6 sm:w-8 dark:bg-gray-600 bg-gray-200 rounded border dark:border-border-400 border-gray-200 animate-pulse"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var SubstitutionsSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between dark:bg-black-400 bg-white_theme-50 rounded-md mt-2 px-2 py-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-3 sm:h-4 w-24 sm:w-32 dark:bg-gray-600 bg-gray-200 rounded animate-pulse mb-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "space-y-3 pl-0",
                        children: Array.from({
                            length: 2
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubstitutionItemSkeleton, {}, "home-".concat(index));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-3 sm:h-4 w-24 sm:w-32 dark:bg-gray-600 bg-gray-200 rounded animate-pulse mb-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex flex-col items-end space-y-3 pl-0",
                        children: Array.from({
                            length: 2
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubstitutionItemSkeleton, {
                                reverse: true
                            }, "away-".concat(index));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var subcomponents_SubstitutionsSkeleton = (SubstitutionsSkeleton);

;// CONCATENATED MODULE: ./src/components/molecules/LivesoreFormationDetails/subcomponents/StartersSkeleton.tsx



var StarterItemSkeleton = function(param) {
    var _reverse = param.reverse, reverse = _reverse === void 0 ? false : _reverse;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (0,cn.cn)("flex items-center gap-1", reverse ? "flex-row-reverse" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-2 sm:h-3 w-4 sm:w-5 dark:bg-gray-600 bg-gray-200 rounded animate-pulse"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[7px] h-[7px] sm:w-[10px] sm:h-[10px] dark:bg-gray-600 bg-gray-200 rounded-full animate-pulse"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-2 sm:h-3 w-16 sm:w-20 dark:bg-gray-600 bg-gray-200 rounded animate-pulse"
            })
        ]
    });
};
var StartersSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-3 sm:h-4 w-24 sm:w-32 dark:bg-gray-600 bg-gray-200 rounded animate-pulse mb-2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "pl-0 list-none space-y-2 sm:space-y-2.5",
                        children: Array.from({
                            length: 11
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StarterItemSkeleton, {}, "home-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "pl-0 list-none space-y-2 sm:space-y-2.5",
                        children: Array.from({
                            length: 11
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StarterItemSkeleton, {
                                reverse: true
                            }, "away-".concat(index));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var subcomponents_StartersSkeleton = (StartersSkeleton);

;// CONCATENATED MODULE: ./src/components/molecules/LivesoreFormationDetails/subcomponents/SubstitutesSkeleton.tsx



var SubstituteItemSkeleton = function(param) {
    var _reverse = param.reverse, reverse = _reverse === void 0 ? false : _reverse;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (0,cn.cn)("flex items-center gap-1", reverse ? "flex-row-reverse" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-2 sm:h-3 w-4 sm:w-5 dark:bg-gray-600 bg-gray-200 rounded animate-pulse"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[7px] h-[7px] sm:w-[10px] sm:h-[10px] dark:bg-gray-600 bg-gray-200 rounded-full animate-pulse"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-2 sm:h-3 w-16 sm:w-20 dark:bg-gray-600 bg-gray-200 rounded animate-pulse"
            })
        ]
    });
};
var SubstitutesSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-3 sm:h-4 w-20 sm:w-24 dark:bg-gray-600 bg-gray-200 rounded animate-pulse mb-2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "pl-0 list-none space-y-2 sm:space-y-2.5",
                        children: Array.from({
                            length: 7
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubstituteItemSkeleton, {}, "home-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "pl-0 list-none space-y-2 sm:space-y-2.5",
                        children: Array.from({
                            length: 7
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubstituteItemSkeleton, {
                                reverse: true
                            }, "away-".concat(index));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var subcomponents_SubstitutesSkeleton = (SubstitutesSkeleton);

;// CONCATENATED MODULE: ./src/components/molecules/LivesoreFormationDetails/LivescoreFormationDetails.tsx




















var smartWidths = {
    // For 2 lines (e.g., Goalkeeper + the rest)
    "2": [
        15,
        85
    ],
    // For 3 lines (e.g., Goalkeeper, Defenders, the rest)
    "3": [
        15,
        40,
        45
    ],
    // For 4 lines (e.g., Goalkeeper, Defenders, Midfielders, Forwards -> as in 4-3-3)
    "4": [
        15,
        35,
        30,
        20
    ],
    // For 5 lines (e.g., Goalkeeper, Defenders, Def. Midfielders, Off. Midfielders, Forwards -> as in 4-2-3-1)
    "5": [
        15,
        30,
        20,
        20,
        15
    ]
};
var Player = function(param) {
    var player = param.player, showStats = param.showStats, competitor = param.competitor;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var match = useLivescoreMatch().match;
    var width = (0,useWindowResize/* useWindowSize */.i)().width;
    var ref7;
    var stats = (ref7 = (ref5 = (ref3 = match === null || match === void 0 ? void 0 : (ref = match.statistics) === null || ref === void 0 ? void 0 : (ref1 = ref.totals) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.competitors) === null || ref2 === void 0 ? void 0 : ref2.find(function(c) {
        return c.qualifier === competitor;
    })) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.players) === null || ref4 === void 0 ? void 0 : ref4.find(function(p) {
        return p.id === player.id;
    })) === null || ref5 === void 0 ? void 0 : ref5.statistics) !== null && ref7 !== void 0 ? ref7 : {};
    var _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LivescoreEntityLink/* default */.Z, {
        href: "/livescore/player/".concat(player.slug ? player.slug : player.id),
        className: (0,cn.cn)("relative pb-3", competitor === "away" && player.type === "goalkeeper" && "translate-y-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-10 h-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: player.img ? player.img : "/images/player.png",
                    alt: player.name,
                    layout: "fill",
                    objectFit: "contain",
                    className: "w-full absolute rounded-t-xl"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute sm:bottom-[1px] bottom-1 left-1/2 -translate-x-1/2 flex items-center flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-end",
                        children: [
                            !player.starter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h-2 w-2.5 sm:h-[10px] sm:w-3.5 rounded-t-[2.5px] dark:bg-white bg-black flex items-center justify-center ml-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Substitution, {
                                    width: width ? width > 600 ? 9 : 7 : 7,
                                    height: width ? width > 600 ? 9 : 7 : 7,
                                    className: "mr-0.5"
                                })
                            }) : null,
                            showStats && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,cn.cn)("-mb-[2px]", player.starter ? "pl-8" : "pl-6"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescorePlayerStats/* default */.Z, {
                                    stats: stats,
                                    position: (_type = player.type) !== null && _type !== void 0 ? _type : ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-black dark:text-white sm:text-[9px] text-[8px] dark:bg-gray-650 bg-white_theme-100 w-max px-[7.5px] py-[2.5px] rounded-[5px]",
                        children: [
                            player.jersey_number,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                className: "ml-0.5 sm:ml-0",
                                children: player === null || player === void 0 ? void 0 : (ref6 = player.name) === null || ref6 === void 0 ? void 0 : ref6.split(",")[0]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var LivescoreFormationDetails = function() {
    var ref, ref1;
    var ref2 = useLivescoreMatch(), match = ref2.match, formation = ref2.formation, setFormation = ref2.setFormation, setSubstitutes = ref2.setSubstitutes, setSubstitutions = ref2.setSubstitutions, setStarters = ref2.setStarters;
    var ref3 = (0,react.useState)(true), loading = ref3[0], setLoading = ref3[1];
    var width = (0,useWindowResize/* useWindowSize */.i)().width;
    (0,react.useEffect)(function() {
        if (formation) {
            setLoading(false);
            return;
        }
        var getFormation = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var formationResponse;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            return [
                                4,
                                client/* livescoreClient.apiFormationsEventIdGet */.Z.apiFormationsEventIdGet({
                                    eventId: match.sport_event.id
                                })
                            ];
                        case 1:
                            formationResponse = _state.sent();
                            setFormation(formationResponse.data.data.formations);
                            setSubstitutes(formationResponse.data.data.substitutes);
                            setSubstitutions(formationResponse.data.data.substitutions);
                            setStarters(formationResponse.data.data.starters);
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getFormation() {
                return _ref.apply(this, arguments);
            };
        }();
        getFormation();
    }, []);
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full relative sm:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full aspect-[1/1.49647] sm:aspect-[1.49647]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/field.svg",
                            alt: "boisko",
                            layout: "fill",
                            objectFit: "contain",
                            className: (0,cn.cn)(loading || width === undefined && "animate-pulse", "rotate-90 sm:rotate-0 scale-[1.49647] sm:scale-100")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,cn.cn)("absolute inset-0 flex sm:flex-row flex-col", loading || width === undefined ? "sm:px-8" : "py-4"),
                        children: formation && width ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-full sm:h-full h-1/2 flex sm:flex-row flex-col sm:pr-4 sm:pl-2 py-2 sm:py-0 sm:translate-y-0",
                                    children: formation === null || formation === void 0 ? void 0 : (ref = formation.home) === null || ref === void 0 ? void 0 : ref.map(function(value, index) {
                                        var ref, ref1;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: (0,_define_property/* default */.Z)({}, width > 600 ? "width" : "height", "".concat((formation === null || formation === void 0 ? void 0 : (ref = formation.home) === null || ref === void 0 ? void 0 : ref.length) ? smartWidths["".concat(formation === null || formation === void 0 ? void 0 : (ref1 = formation.home) === null || ref1 === void 0 ? void 0 : ref1.length)][index] : 100, "%")),
                                            className: (0,cn.cn)("flex sm:flex-col flex-row-reverse justify-center items-center", value.length > 4 ? "justify-around" : "justify-center gap-12"),
                                            children: (0,_to_consumable_array/* default */.Z)(value).reverse().map(function(player) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Player, {
                                                    showStats: !PREMATCH_STATUSES.includes(match.sport_event_status.status),
                                                    player: player,
                                                    competitor: "home"
                                                }, player.name);
                                            })
                                        }, "home ".concat(index));
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-full sm:h-full h-1/2 flex sm:flex-row flex-col sm:pl-4 sm:pr-3 py-2 sm:py-0",
                                    children: (ref1 = (0,_to_consumable_array/* default */.Z)((ref4 = formation === null || formation === void 0 ? void 0 : formation.away) !== null && ref4 !== void 0 ? ref4 : [])) === null || ref1 === void 0 ? void 0 : ref1.reverse().map(function(value, index) {
                                        var ref, ref1, ref2;
                                        var ref3;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: (0,_define_property/* default */.Z)({}, width > 600 ? "width" : "height", "".concat((formation === null || formation === void 0 ? void 0 : (ref = formation.away) === null || ref === void 0 ? void 0 : ref.length) ? smartWidths["".concat(formation === null || formation === void 0 ? void 0 : (ref1 = formation.away) === null || ref1 === void 0 ? void 0 : ref1.length)][index] : 100, "%")),
                                            className: (0,cn.cn)("w-full flex sm:flex-col flex-row-reverse items-center", value.length > 4 ? "justify-around" : "justify-center gap-12", index === ((ref3 = formation === null || formation === void 0 ? void 0 : (ref2 = formation.away) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref3 !== void 0 ? ref3 : 0) - 1 && "items-end sm:-translate-x-0"),
                                            children: value.map(function(player) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Player, {
                                                    showStats: !PREMATCH_STATUSES.includes(match.sport_event_status.status),
                                                    player: player,
                                                    competitor: "away"
                                                }, player.name);
                                            })
                                        }, "away ".concat(index));
                                    })
                                })
                            ]
                        }) : !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-xs dark:bg-black-500 bg-white_theme-100 dark:sm:text-gray-400 sm:text-gray-600 uppercase font-medium backdrop-blur-lg w-max px-3 py-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                            children: "Nie znaleziono formacji dla tego meczu"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4",
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(subcomponents_SubstitutionsSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(subcomponents_StartersSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(subcomponents_SubstitutesSkeleton, {})
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(subcomponents_Substitutions, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(subcomponents_Starters, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(subcomponents_Substitutes, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var LivesoreFormationDetails_LivescoreFormationDetails = (LivescoreFormationDetails);

// EXTERNAL MODULE: ./src/context/LivescoreSeasonTableContext.tsx
var LivescoreSeasonTableContext = __webpack_require__(25950);
;// CONCATENATED MODULE: ./src/components/organisms/LivescoreMatchContent/LivescoreMatchContent.tsx












var PREMATCH_FILTER_BUTTONS = [
    {
        label: "Szczeg\xf3ły",
        id: "details"
    },
    {
        label: "Składy",
        id: "lineups"
    },
    // {
    //   label: 'Kursy',
    //   id: 'odds',
    // },
    {
        label: "H2H",
        id: "h2h"
    },
    {
        label: "Tabela",
        id: "table"
    }, 
];
var FILTER_BUTTONS = [
    {
        label: "Relacja na żywo",
        id: "live"
    },
    {
        label: "Statystyki",
        id: "stats"
    },
    {
        label: "Składy",
        id: "lineups"
    },
    // {
    //   label: 'Kursy',
    //   id: 'odds',
    // },
    {
        label: "h2h",
        id: "h2h"
    },
    {
        label: "Tabela",
        id: "table"
    }, 
];
var LivescoreMatchContent = function() {
    var ref;
    var match = useLivescoreMatch().match;
    var ref1;
    var ref2 = (0,react.useState)(PREMATCH_STATUSES.includes((ref1 = match === null || match === void 0 ? void 0 : (ref = match.sport_event_status) === null || ref === void 0 ? void 0 : ref.status) !== null && ref1 !== void 0 ? ref1 : "") ? PREMATCH_FILTER_BUTTONS[0]["id"] : FILTER_BUTTONS[0]["id"]), filter = ref2[0], setFilter = ref2[1];
    0;
    var LivescoreMatchContentSwitch = (0,react.useMemo)(function() {
        if (PREMATCH_STATUSES.includes(match.sport_event_status.status)) {
            switch(filter){
                case "details":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchDetails_LivescoreMatchDetails, {});
                case "lineups":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivesoreFormationDetails_LivescoreFormationDetails, {});
                // case 'odds':
                //   return <div>Kursy</div>;
                case "h2h":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreH2HDetails_LivescoreH2HDetails, {});
                case "table":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreSeasonTable/* default */.Z, {});
                default:
                    return null;
            }
        } else {
            switch(filter){
                case "live":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchReport_LivescoreMatchRaport, {});
                case "stats":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchStatistics_LivescoreMatchStatistics, {});
                case "lineups":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivesoreFormationDetails_LivescoreFormationDetails, {});
                // case 'odds':
                //   return <div>Kursy</div>;
                case "h2h":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreH2HDetails_LivescoreH2HDetails, {});
                case "table":
                    var ref, ref1;
                    var ref2, ref3;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreSeasonTable/* default */.Z, {
                        score: match.sport_event_status.status === "live" ? {
                            home: {
                                id: (ref2 = (ref = match.sport_event.competitors.find(function(c) {
                                    return c.qualifier === "home";
                                })) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : "",
                                score: match.sport_event_status.home_score
                            },
                            away: {
                                id: (ref3 = (ref1 = match.sport_event.competitors.find(function(c) {
                                    return c.qualifier === "away";
                                })) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref3 !== void 0 ? ref3 : "",
                                score: match.sport_event_status.away_score
                            }
                        } : undefined
                    });
                default:
                    return null;
            }
        }
    }, [
        filter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mb-4 mt-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (0,cn.cn)("list-none pl-0 flex flex-row gap-2 sm:w-fit w-full sm:overflow-x-auto overflow-x-scroll rounded-lg"),
                    children: (PREMATCH_STATUSES.includes(match.sport_event_status.status) ? PREMATCH_FILTER_BUTTONS : FILTER_BUTTONS).map(function(param) {
                        var label = param.label, id = param.id;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "primaryGlass",
                                type: "button",
                                className: (0,cn.cn)("uppercase sm:text-[11px] text-[8px] !text-primary-600 py-2 px-4 w-max", filter === id && "!bg-primary-600 dark:!text-black-500 !text-white"),
                                onClick: function() {
                                    setFilter(id);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "line-clamp-1 overflow-ellipsis",
                                    children: label
                                })
                            }, id)
                        });
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreSeasonTableContext/* LivescoreSeasonTableProvider */.vb, {
                seasonId: match.sport_event.sport_event_context.season.id,
                children: LivescoreMatchContentSwitch
            })
        ]
    });
};
/* harmony default export */ var LivescoreMatchContent_LivescoreMatchContent = (LivescoreMatchContent);

;// CONCATENATED MODULE: ./src/components/templates/MatchTemplate/MatchTemplate.tsx






var MatchTemplate = function(param) {
    var match = param.match, adsSidebar = param.adsSidebar, adsMatch = param.adsMatch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreLayout/* default */.Z, {
        ads: adsSidebar,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchProvider, {
            initMatch: match,
            ads: adsMatch,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "border dark:border-border-400 border-gray-250 rounded-lg dark:bg-black-500 bg-white !shrink-0 !grow-0 !h-fit",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchHeader_LivescoreMatchHeader, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchResult_LivescoreMatchResult, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sm:p-4 p-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "sr-only",
                                children: [
                                    match.sport_event.competitors[0].name,
                                    " - ",
                                    match.sport_event.competitors[1].name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LivescoreMatchContent_LivescoreMatchContent, {})
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var MatchTemplate_MatchTemplate = (MatchTemplate);

;// CONCATENATED MODULE: ./src/pages/livescore/match/[id].tsx




var __N_SSP = true;
var buildMatchPageTitle = function(match) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var homeCompetitor = match === null || match === void 0 ? void 0 : (ref = match.sport_event) === null || ref === void 0 ? void 0 : (ref1 = ref.competitors) === null || ref1 === void 0 ? void 0 : ref1.find(function(c) {
        return c.qualifier === "home";
    });
    var awayCompetitor = match === null || match === void 0 ? void 0 : (ref2 = match.sport_event) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.competitors) === null || ref3 === void 0 ? void 0 : ref3.find(function(c) {
        return c.qualifier === "away";
    });
    var ref9, ref10;
    var abb = "".concat(homeCompetitor === null || homeCompetitor === void 0 ? void 0 : homeCompetitor.abbreviation, " ").concat((ref9 = match === null || match === void 0 ? void 0 : (ref4 = match.sport_event_status) === null || ref4 === void 0 ? void 0 : ref4.home_score) !== null && ref9 !== void 0 ? ref9 : "", "-").concat((ref10 = match === null || match === void 0 ? void 0 : (ref5 = match.sport_event_status) === null || ref5 === void 0 ? void 0 : ref5.away_score) !== null && ref10 !== void 0 ? ref10 : "", " ").concat(awayCompetitor === null || awayCompetitor === void 0 ? void 0 : awayCompetitor.abbreviation);
    var ref11;
    var date = new Date((ref11 = match === null || match === void 0 ? void 0 : (ref6 = match.sport_event) === null || ref6 === void 0 ? void 0 : ref6.start_time) !== null && ref11 !== void 0 ? ref11 : "");
    var formattedDate = String(date.getDate()).padStart(2, "0") + "/" + String(date.getMonth() + 1).padStart(2, "0") + "/" + date.getFullYear();
    var names = "".concat(homeCompetitor === null || homeCompetitor === void 0 ? void 0 : homeCompetitor.name, " - ").concat(awayCompetitor === null || awayCompetitor === void 0 ? void 0 : awayCompetitor.name, " ").concat((match === null || match === void 0 ? void 0 : (ref7 = match.sport_event) === null || ref7 === void 0 ? void 0 : ref7.start_time) ? formattedDate : "");
    var closedStatuses = [
        "closed",
        "ended",
        "abandoned",
        "cancelled"
    ];
    var endfix = closedStatuses.includes(match === null || match === void 0 ? void 0 : (ref8 = match.sport_event_status) === null || ref8 === void 0 ? void 0 : ref8.status) ? "Wyniki i statystyki" : "NA ŻYWO, H2H, składy";
    return "".concat(abb, " | ").concat(names, " | ").concat(endfix);
};
var buildMatchPageDescription = function(match) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var upcomingStatuses = [
        "not_started",
        "postponed",
        "delayed"
    ];
    var homeName = (ref2 = match === null || match === void 0 ? void 0 : (ref = match.sport_event) === null || ref === void 0 ? void 0 : (ref1 = ref.competitors) === null || ref1 === void 0 ? void 0 : ref1.find(function(c) {
        return c.qualifier === "home";
    })) === null || ref2 === void 0 ? void 0 : ref2.name;
    var awayName = (ref5 = match === null || match === void 0 ? void 0 : (ref3 = match.sport_event) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.competitors) === null || ref4 === void 0 ? void 0 : ref4.find(function(c) {
        return c.qualifier === "away";
    })) === null || ref5 === void 0 ? void 0 : ref5.name;
    var result = "".concat(match === null || match === void 0 ? void 0 : (ref6 = match.sport_event_status) === null || ref6 === void 0 ? void 0 : ref6.home_score, " - ").concat(match === null || match === void 0 ? void 0 : (ref7 = match.sport_event_status) === null || ref7 === void 0 ? void 0 : ref7.away_score);
    var date = (match === null || match === void 0 ? void 0 : (ref8 = match.sport_event) === null || ref8 === void 0 ? void 0 : ref8.start_time) ? " ".concat(new Date(match === null || match === void 0 ? void 0 : (ref9 = match.sport_event) === null || ref9 === void 0 ? void 0 : ref9.start_time).toLocaleDateString()) : "";
    if (upcomingStatuses.includes(match === null || match === void 0 ? void 0 : (ref10 = match.sport_event_status) === null || ref10 === void 0 ? void 0 : ref10.status)) {
        return "Śledź mecz ".concat(homeName, " - ").concat(awayName, " na żywo! Sprawdź aktualne składy, statystyki H2H, formę zespoł\xf3w i przewidywania przed spotkaniem").concat(date, ". Bądź na bieżąco z Fangol!");
    }
    return "Wynik meczu ".concat(homeName, " - ").concat(awayName, " (").concat(result, "). Zobacz szczeg\xf3łowe statystyki, strzelc\xf3w bramek, posiadanie piłki i podsumowanie spotkania").concat(date ? " z dnia".concat(date) : "", ". Wszystko w jednym miejscu.");
};
var MatchPage = function(param) {
    var match = param.match, adsSidebar = param.adsSidebar, adsMatch = param.adsMatch, competitions = param.competitions, favoriteMatches = param.favoriteMatches, favoriteCompetitors = param.favoriteCompetitors;
    if (!match) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "test"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LivescoreLayoutContext/* LivescoreLayoutProvider */.Z, {
        competitions: competitions,
        favoriteMatchesInit: favoriteMatches,
        favoriteCompetitorsInit: favoriteCompetitors,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: buildMatchPageTitle(match)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: buildMatchPageDescription(match)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchTemplate_MatchTemplate, {
                match: match,
                adsSidebar: adsSidebar,
                adsMatch: adsMatch
            })
        ]
    });
};
/* harmony default export */ var _id_ = (MatchPage);


/***/ }),

/***/ 47370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ redStatuses; },
/* harmony export */   "L$": function() { return /* binding */ getMatchStatus; },
/* harmony export */   "YH": function() { return /* binding */ greenStatuses; },
/* harmony export */   "jA": function() { return /* binding */ blackStatuses; },
/* harmony export */   "pL": function() { return /* binding */ grayStatuses; }
/* harmony export */ });
var blackStatuses = [
    "NIE ZACZĘTY"
];
var redStatuses = [
    "PRZERWANY",
    "PORZUCONY",
    "PRZEŁOŻONY",
    "OP\xd3ŹNIONY",
    "ANULOWANY",
    "ZAWIESZONY"
];
var greenStatuses = [
    "ROZPOCZĘTY",
    "RZUTY KARNE",
    "PRZERWA",
    "PRZERWA W DOGRYWCE",
    "LIVE",
    "1. POŁ",
    "2. POŁ", 
];
var grayStatuses = [
    "ZAKOŃCZONE RZUTAMI KARNYMI",
    "ZAKOŃCZONE DOGRYWKĄ",
    "DOGRYWKA",
    "1. POŁ DOGRYWKI",
    "2. POŁ DOGRYWKI",
    "OCZEKIWANIE NA RZUTY KARNE",
    "OCZEKIWANIE NA DOGRYWKĘ",
    "ZAKOŃCZONE", 
];
function translateMatchStatus(status) {
    switch(status){
        case "not_started":
            return "NIE ZACZĘTY";
        case "started":
            return "ROZPOCZĘTY";
        case "live":
            return "LIVE";
        case "postponed":
            return "PRZEŁOŻONY";
        case "suspended":
            return "ZAWIESZONY";
        case "delayed":
            return "OP\xd3ŹNIONY";
        case "interrupted":
            return "PRZERWANY";
        case "cancelled":
            return "ANULOWANY";
        case "ended":
        case "clossed":
            return "ZAKOŃCZONE";
        case "abandoned":
            return "PORZUCONY";
        default:
            return undefined;
    }
}
function translateDetailedMatchStatus(status) {
    switch(status){
        case "not_started":
            return "NIE ZACZĘTY";
        case "started":
            return "ROZPOCZĘTY";
        case "1st_half":
            return "1. POŁ";
        case "2nd_half":
            return "2. POŁ";
        case "overtime":
            return "DOGRYWKA";
        case "1st_extra":
            return "1. POŁ DOGRYWKI";
        case "2nd_extra":
            return "2. POŁ DOGRYWKI";
        case "awaiting_penalties":
            return "OCZEKIWANIE NA RZUTY KARNE";
        case "penalties":
            return "RZUTY KARNE";
        case "awaiting_extra_time":
            return "OCZEKIWANIE NA DOGRYWKĘ";
        case "interrupted":
            return "PRZERWANY";
        case "abandoned":
            return "PORZUCONY";
        case "postponed":
            return "PRZEŁOŻONY";
        case "start_delayed":
            return "OP\xd3ŹNIONY";
        case "cancelled":
            return "ANULOWANY";
        case "halftime":
            return "PRZERWA";
        case "extra_time_halftime":
            return "PRZERWA W DOGRYWCE";
        case "ended":
            return "ZAKOŃCZONE";
        case "aet":
            return "ZAKOŃCZONE DOGRYWKĄ";
        case "ap":
            return "ZAKOŃCZONE RZUTAMI KARNYMI";
        default:
            return undefined;
    }
}
/**
 * Figure out match status in polish based on match_status (more detailed) or status (less detailed)
 * @param status
 * @returns match status in polish based on match status
 */ function getMatchStatus(status) {
    var _match_status;
    var matchStatus = translateDetailedMatchStatus((_match_status = status.match_status) !== null && _match_status !== void 0 ? _match_status : "");
    if (matchStatus) {
        return matchStatus;
    }
    return translateMatchStatus(status.status);
}


/***/ }),

/***/ 13245:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.5 8.25-7.5 7.5-7.5-7.5"
  }));
}
const ForwardRef = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronDownIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7226,3882,3017,9781,9774,2888,179], function() { return __webpack_exec__(81544); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);